
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as b2baQz65LfmwVw2UwS4Ku38V4RNfufsMBGdmBk940PvH_45EMeta } from "/app/pages/b2b.vue?macro=true";
import { default as devdjDB5yG1649kY6yMbqWxgn7OuNYXY2QzAQAi7xiCGLAMeta } from "/app/pages/dev.vue?macro=true";
import { default as faqpXvNV3IVqZ7r7EZ6X3TxlTw6jDWpvHRhXzG2SNVEy_4Meta } from "/app/pages/faq.vue?macro=true";
import { default as tosUnbYuckNIzZ5Ba0gelRujodHJ3WLIwNKFtCVeDrd474Meta } from "/app/pages/tos.vue?macro=true";
import { default as indexndqPXFtP262szLmLJV4PriPTgAg5k_457f05QyTfosBXQMeta } from "/app/pages/index.vue?macro=true";
import { default as loginKGJhNRZhH4FU_45RnHfId5ZCGRhKzPnQPbdAbdNd47TwsMeta } from "/app/pages/login.vue?macro=true";
import { default as imprinthkouq5hSidrpTSuflE7DpDLLzD4EE_45s4nlZ8qXwh8sIMeta } from "/app/pages/imprint.vue?macro=true";
import { default as pricingo1KWFKLyd5spZjtCwrwVvX23I_qnlyTFJchpkfnF_sUMeta } from "/app/pages/pricing.vue?macro=true";
import { default as privacyxyrJyjSeOpGN_D08QZsO5Csr7DLueZBtja09XVxe_45u0Meta } from "/app/pages/privacy.vue?macro=true";
import { default as product7MdlkxMtuBnvq2LPuiieYQHw9k_45XWBr4NXxwRdtRaM4Meta } from "/app/pages/product.vue?macro=true";
import { default as featuresCI_45NDYUfnZkzIjb1hcOQ3yLLEPvCItM1Aj7mxRKaacIMeta } from "/app/pages/features.vue?macro=true";
import { default as registerhhTixNN_gvg3OZSt2Nh0apJnSWfEASm8HSODFR1YEGYMeta } from "/app/pages/register.vue?macro=true";
import { default as _91_46_46_46slug_93QkkyEDg6xOGuFkoxzFC_4565xuuMFULoZbO_183vt2UD8Meta } from "/app/pages/[...slug].vue?macro=true";
import { default as warmingupMnr4SdCQ2et9WuOA79Cs8Dj_OBTQ1036rKKN2fhbnikMeta } from "/app/pages/warmingup.vue?macro=true";
import { default as indexXDrvC4X9cQh98rUTaKV7n9SAzKfJcTLnbJGv9g_YdesMeta } from "/app/pages/blog/index.vue?macro=true";
import { default as indexQ_45p_R8nWqy4cZICdOG47zZGdB894pqt8jkBF_45IT0qhIMeta } from "/app/pages/home/index.vue?macro=true";
import { default as indexPyNEnibr09aLgqiv_45SpBIx0DO1WtxEmSAZ8_45j76P09oMeta } from "/app/pages/wiki/index.vue?macro=true";
import { default as indexTGVRyIYXFCTpuXeAxrmeJ5DABJSwZkuf_45KtLwWt4pl0Meta } from "/app/pages/tools/index.vue?macro=true";
import { default as cancellation8CFKB6vkC2GT4V6k5l85_452MRlppTlHzRqvNwwZIF9uAMeta } from "/app/pages/cancellation.vue?macro=true";
import { default as confirm_45emailmOQPuQsguw3wpmY58YmTJo9FKxdfbof0kTYkEAlEayEMeta } from "/app/pages/confirm-email.vue?macro=true";
import { default as indexVx65biFkALNIci1zzKZ3d0OHFh0_HEts7VMKczcHueAMeta } from "/app/pages/home/settings/index.vue?macro=true";
import { default as theme1cH5MLEJvOONGqMYGGotTpm_45qVivrq6F_45SxQkS6jp_AMeta } from "/app/pages/home/settings/theme.vue?macro=true";
import { default as accountO2BlFkJIUbW11_45ZwGZyDPVl1rqmC8CcZ_6AdQAn3FVYMeta } from "/app/pages/home/settings/account.vue?macro=true";
import { default as affiliatesw3vdh_BruIcpunhV9nAT5zLgFWchtDj_sIF0j9M0rBUMeta } from "/app/pages/home/settings/affiliates.vue?macro=true";
import { default as blogsLpbRwjCCRst86oQIg_nPiKA_w0D5dg0j8uOHuTADyx0Meta } from "/app/pages/home/settings/admin/blogs.vue?macro=true";
import { default as rolesSDqQahvXZ8fZlOthsYLnyRdTZAZ_X3YFDhUaT96kXR4Meta } from "/app/pages/home/settings/admin/roles.vue?macro=true";
import { default as usersymV02S7AQE09GEmv_459Mm219AUa_Sa5LC9RxpqJIvdxIMeta } from "/app/pages/home/settings/admin/users.vue?macro=true";
import { default as flightschool9wh7iopRIf3HKCmXLf6G1XlgQ_45_45_s0GEf65sl_45_45tS_QMeta } from "/app/pages/home/settings/flightschool.vue?macro=true";
import { default as notificationsbiHMOzica0CAku1pCsUX9O66BJxIbueEk6RR5XGHjvQMeta } from "/app/pages/home/settings/notifications.vue?macro=true";
import { default as subscriptionsJjhQNuTkSKZvtKTTQYzKs4MFN0OU4a7pchlEUuW_45dw4Meta } from "/app/pages/home/settings/subscriptions.vue?macro=true";
import { default as scenariosrpiTooaKF8Nr9hq1Mx543qJUuvi31q1h_3Fa6HAj71UMeta } from "/app/pages/home/settings/admin/scenarios.vue?macro=true";
import { default as payment_45methodsaPv9bJvzMKlSGk3feMz0wP1mUfkr8UAbqSHNPOZwnC8Meta } from "/app/pages/home/settings/payment-methods.vue?macro=true";
import { default as activitieskw4f_45D0Y_452f_KDVY0X1be0SelnKKo91L5przdxdkn6gMeta } from "/app/pages/home/settings/admin/activities.vue?macro=true";
import { default as transmissionsUXqIqd9g6C3e6JKNtIiCwDQonBmsbss2_45KdjJdldlG4Meta } from "/app/pages/home/settings/admin/transmissions.vue?macro=true";
import { default as settingsjVeY63OdxoPmKajnN2v_45iXJDIPUjqn2x3IvdE5CApQsMeta } from "/app/pages/home/settings.vue?macro=true";
import { default as forgot_45passwordgdzNcmliYSc_RqJLDFi4QKABybrSV1OTdLl0SK_45V07UMeta } from "/app/pages/forgot-password.vue?macro=true";
import { default as proceduresHNlWfk6SK18XWNE6erAZB2_45u8AlNzf7R6nMEeH8CdwgMeta } from "/app/pages/wiki/procedures.vue?macro=true";
import { default as indexW7_QmpKzZwgulw6Co_q1glrYDmBLA_45PTzNOdPHETWIEMeta } from "/app/pages/home/school/index.vue?macro=true";
import { default as complete_45setupz_JioV9DqbWWOR_45ufF_45WOJQydUteCUeQboa3pj38K5MMeta } from "/app/pages/home/complete-setup.vue?macro=true";
import { default as coursess2NmmdsfCaGv12LmEFn3VUzMP6o6Vmhi5qHyugaPVHQMeta } from "/app/pages/home/school/courses.vue?macro=true";
import { default as simulatorOnBuwF9qRw_on8VZhqCqMBp5eN2JHQS4EtEGZillp1cMeta } from "/app/pages/home/school/simulator.vue?macro=true";
import { default as _91_46_46_46username_93_cghJM4U8ZqjGBHdxtt920persmljFR9OIu4xvYTVYcMeta } from "/app/pages/profile/[...username].vue?macro=true";
import { default as indextPOgS5yRV0RoUcrkCyWuNETYYU2X5LEBfcQBOOfqznIMeta } from "/app/pages/tools/aerodrome/index.vue?macro=true";
import { default as indexZvlKJBrQa_nID3dzmlvyEnYSNeo0HtJipMaPpwPdqxQMeta } from "/app/pages/tools/frequency/index.vue?macro=true";
import { default as _91icao_93d08hvSepwj_cT6iE3GZK26cTPpBMYpjUDg8CH_R9BiUMeta } from "/app/pages/tools/aerodrome/[icao].vue?macro=true";
import { default as _91icao_93D0MGNpW8DioHbr17O_45Sx_AQc_451dnrFUWZL4Ylq81rksMeta } from "/app/pages/tools/frequency/[icao].vue?macro=true";
import { default as index3T38SgftPvwWc3JDNnYhykwB5ig5t9BzcsSH7kpBgGsMeta } from "/app/pages/tools/flightschool/index.vue?macro=true";
import { default as indexPNCnWdQAFO1tMbEz1leGuWjAV1LL8FlxzebsPUseNaQMeta } from "/app/pages/home/school/lections/index.vue?macro=true";
import { default as _91id_931U5t1ns0J6X5BW5pu_Q5NmkbTjaiuf_45gfpiz2GxRUf8Meta } from "/app/pages/home/school/scenarios/[id].vue?macro=true";
import { default as indexj6YLQLkprw6TVyw2HkwdAy0qc9GdhbCJYrcpkFR6PkwMeta } from "/app/pages/home/school/training/index.vue?macro=true";
import { default as indexexOpWq1WllquRN0wtg8dM5Vl9vnpmSTywBjPdrpEC2cMeta } from "/app/pages/home/school/questions/index.vue?macro=true";
import { default as index_0WapMMTF1480iJPuPgRMrBtM1yMO1GcEfmCSm5x0xoMeta } from "/app/pages/home/school/scenarios/index.vue?macro=true";
import { default as _91school_93S8aNTfFhZNWoHoWYCDftpTPOSpyhvY6ffGehZPgVcHgMeta } from "/app/pages/tools/flightschool/[school].vue?macro=true";
import { default as spellingXOi3_LwNiFvWzJd7UqnfAhCnn_45D5gemUIVMyvzFaJg0Meta } from "/app/pages/home/school/training/spelling.vue?macro=true";
import { default as lection_45_91id_93TwJE4cfPjQPSdQGPlKYEYJyk9wDnKpsvlXJiS06ljEkMeta } from "/app/pages/home/school/lections/lection-[id].vue?macro=true";
import { default as lection_45old_451IAi7I_b37pKuqHJicK0TzEs1evdFJV5YJZvbI_rkj_kMeta } from "/app/pages/home/school/lections/lection-old-1.vue?macro=true";
import { default as lection_45old_452lNAuY_45h0coVA1JzqFyP_45UyClasCy8qmP8onkkA1PAFAMeta } from "/app/pages/home/school/lections/lection-old-2.vue?macro=true";
import { default as lection_45old_453n6ohDp4AGRHn24ltFroyAo40I98BhsD7j1wXNWgoN8wMeta } from "/app/pages/home/school/lections/lection-old-3.vue?macro=true";
import { default as lection_45old_454mkTsQ9KELrRb42_45nIfI16Jkf1jeCyLd67SToBFAHFJoMeta } from "/app/pages/home/school/lections/lection-old-4.vue?macro=true";
import { default as lection_45old_4557MQ1vwUSHRfGlZQz1TF9SGB8_GZqQwNPONfWRujSCdUMeta } from "/app/pages/home/school/lections/lection-old-5.vue?macro=true";
import { default as lection_45old_4569BliQv_UPNO6OrS5W3cajToiHwKa_45iGLb3okDyoPyrsMeta } from "/app/pages/home/school/lections/lection-old-6.vue?macro=true";
import { default as indexZLzP_45InkhGD55R6M5FTQRRcGFgO6lVwImxqJzYzwrhQMeta } from "/app/pages/home/school/questions/[license]/index.vue?macro=true";
import { default as indexHfgkwrchuuP1VdZ7P4H26dWRTzRe7pZ8WqvUONYzL7sMeta } from "/app/pages/home/school/questions/[license]/exampreparation/index.vue?macro=true";
import { default as indexhCGq5apkzhfSLkY5fldINtKN9g7hJTEotNdsAMkQfyEMeta } from "/app/pages/home/school/questions/[license]/[category]/[[number]]/index.vue?macro=true";
import { default as index5zDmUjHzzWMBuzUXjOeYMxomexAwmuWD0fENn01sL38Meta } from "/app/pages/home/school/questions/[license]/exampreparation/[exam]/index.vue?macro=true";
import { default as _91completion_93Caq8lVEcZOm9_udTYpcnocS5O79thXONtIesr3NPKGAMeta } from "/app/pages/home/school/questions/[license]/exampreparation/[exam]/result/[completion].vue?macro=true";
import { default as component_45stubxPFW0AyuS0FSsi5abKpdmEVVeey6yOusab24ksP4zsAMeta } from "/app/node_modules/.pnpm/nuxt@3.19.2_@netlify+blobs@9.1.2_@parcel+watcher@2.5.1_@types+node@24.5.2_@vue+compiler_e13cea8ddf122f8ba9a602b6a4003695/node_modules/nuxt/dist/pages/runtime/component-stub.js?macro=true";
import { default as component_45stubxPFW0AyuS0FSsi5abKpdmEVVeey6yOusab24ksP4zsA } from "/app/node_modules/.pnpm/nuxt@3.19.2_@netlify+blobs@9.1.2_@parcel+watcher@2.5.1_@types+node@24.5.2_@vue+compiler_e13cea8ddf122f8ba9a602b6a4003695/node_modules/nuxt/dist/pages/runtime/component-stub.js";
export default [
  {
    name: "b2b___en___default",
    path: "/b2b",
    meta: b2baQz65LfmwVw2UwS4Ku38V4RNfufsMBGdmBk940PvH_45EMeta || {},
    component: () => import("/app/pages/b2b.vue")
  },
  {
    name: "b2b___en",
    path: "/en/b2b",
    meta: b2baQz65LfmwVw2UwS4Ku38V4RNfufsMBGdmBk940PvH_45EMeta || {},
    component: () => import("/app/pages/b2b.vue")
  },
  {
    name: "b2b___de",
    path: "/de/b2b",
    meta: b2baQz65LfmwVw2UwS4Ku38V4RNfufsMBGdmBk940PvH_45EMeta || {},
    component: () => import("/app/pages/b2b.vue")
  },
  {
    name: "b2b___at",
    path: "/at/b2b",
    meta: b2baQz65LfmwVw2UwS4Ku38V4RNfufsMBGdmBk940PvH_45EMeta || {},
    component: () => import("/app/pages/b2b.vue")
  },
  {
    name: "b2b___es",
    path: "/es/b2b",
    meta: b2baQz65LfmwVw2UwS4Ku38V4RNfufsMBGdmBk940PvH_45EMeta || {},
    component: () => import("/app/pages/b2b.vue")
  },
  {
    name: "b2b___uk",
    path: "/uk/b2b",
    meta: b2baQz65LfmwVw2UwS4Ku38V4RNfufsMBGdmBk940PvH_45EMeta || {},
    component: () => import("/app/pages/b2b.vue")
  },
  {
    name: "b2b___ru",
    path: "/ru/b2b",
    meta: b2baQz65LfmwVw2UwS4Ku38V4RNfufsMBGdmBk940PvH_45EMeta || {},
    component: () => import("/app/pages/b2b.vue")
  },
  {
    name: "dev___en___default",
    path: "/dev",
    component: () => import("/app/pages/dev.vue")
  },
  {
    name: "dev___en",
    path: "/en/dev",
    component: () => import("/app/pages/dev.vue")
  },
  {
    name: "dev___de",
    path: "/de/dev",
    component: () => import("/app/pages/dev.vue")
  },
  {
    name: "dev___at",
    path: "/at/dev",
    component: () => import("/app/pages/dev.vue")
  },
  {
    name: "dev___es",
    path: "/es/dev",
    component: () => import("/app/pages/dev.vue")
  },
  {
    name: "dev___uk",
    path: "/uk/dev",
    component: () => import("/app/pages/dev.vue")
  },
  {
    name: "dev___ru",
    path: "/ru/dev",
    component: () => import("/app/pages/dev.vue")
  },
  {
    name: "faq___en___default",
    path: "/faq",
    meta: faqpXvNV3IVqZ7r7EZ6X3TxlTw6jDWpvHRhXzG2SNVEy_4Meta || {},
    component: () => import("/app/pages/faq.vue")
  },
  {
    name: "faq___en",
    path: "/en/faq",
    meta: faqpXvNV3IVqZ7r7EZ6X3TxlTw6jDWpvHRhXzG2SNVEy_4Meta || {},
    component: () => import("/app/pages/faq.vue")
  },
  {
    name: "faq___de",
    path: "/de/faq",
    meta: faqpXvNV3IVqZ7r7EZ6X3TxlTw6jDWpvHRhXzG2SNVEy_4Meta || {},
    component: () => import("/app/pages/faq.vue")
  },
  {
    name: "faq___at",
    path: "/at/faq",
    meta: faqpXvNV3IVqZ7r7EZ6X3TxlTw6jDWpvHRhXzG2SNVEy_4Meta || {},
    component: () => import("/app/pages/faq.vue")
  },
  {
    name: "faq___es",
    path: "/es/faq",
    meta: faqpXvNV3IVqZ7r7EZ6X3TxlTw6jDWpvHRhXzG2SNVEy_4Meta || {},
    component: () => import("/app/pages/faq.vue")
  },
  {
    name: "faq___uk",
    path: "/uk/faq",
    meta: faqpXvNV3IVqZ7r7EZ6X3TxlTw6jDWpvHRhXzG2SNVEy_4Meta || {},
    component: () => import("/app/pages/faq.vue")
  },
  {
    name: "faq___ru",
    path: "/ru/faq",
    meta: faqpXvNV3IVqZ7r7EZ6X3TxlTw6jDWpvHRhXzG2SNVEy_4Meta || {},
    component: () => import("/app/pages/faq.vue")
  },
  {
    name: "tos___en___default",
    path: "/tos",
    component: () => import("/app/pages/tos.vue")
  },
  {
    name: "tos___en",
    path: "/en/tos",
    component: () => import("/app/pages/tos.vue")
  },
  {
    name: "tos___de",
    path: "/de/tos",
    component: () => import("/app/pages/tos.vue")
  },
  {
    name: "tos___at",
    path: "/at/tos",
    component: () => import("/app/pages/tos.vue")
  },
  {
    name: "tos___es",
    path: "/es/tos",
    component: () => import("/app/pages/tos.vue")
  },
  {
    name: "tos___uk",
    path: "/uk/tos",
    component: () => import("/app/pages/tos.vue")
  },
  {
    name: "tos___ru",
    path: "/ru/tos",
    component: () => import("/app/pages/tos.vue")
  },
  {
    name: "index___en___default",
    path: "/",
    meta: indexndqPXFtP262szLmLJV4PriPTgAg5k_457f05QyTfosBXQMeta || {},
    component: () => import("/app/pages/index.vue")
  },
  {
    name: "index___en",
    path: "/en",
    meta: indexndqPXFtP262szLmLJV4PriPTgAg5k_457f05QyTfosBXQMeta || {},
    component: () => import("/app/pages/index.vue")
  },
  {
    name: "index___de",
    path: "/de",
    meta: indexndqPXFtP262szLmLJV4PriPTgAg5k_457f05QyTfosBXQMeta || {},
    component: () => import("/app/pages/index.vue")
  },
  {
    name: "index___at",
    path: "/at",
    meta: indexndqPXFtP262szLmLJV4PriPTgAg5k_457f05QyTfosBXQMeta || {},
    component: () => import("/app/pages/index.vue")
  },
  {
    name: "index___es",
    path: "/es",
    meta: indexndqPXFtP262szLmLJV4PriPTgAg5k_457f05QyTfosBXQMeta || {},
    component: () => import("/app/pages/index.vue")
  },
  {
    name: "index___uk",
    path: "/uk",
    meta: indexndqPXFtP262szLmLJV4PriPTgAg5k_457f05QyTfosBXQMeta || {},
    component: () => import("/app/pages/index.vue")
  },
  {
    name: "index___ru",
    path: "/ru",
    meta: indexndqPXFtP262szLmLJV4PriPTgAg5k_457f05QyTfosBXQMeta || {},
    component: () => import("/app/pages/index.vue")
  },
  {
    name: "login___en___default",
    path: "/login",
    meta: loginKGJhNRZhH4FU_45RnHfId5ZCGRhKzPnQPbdAbdNd47TwsMeta || {},
    component: () => import("/app/pages/login.vue")
  },
  {
    name: "login___en",
    path: "/en/login",
    meta: loginKGJhNRZhH4FU_45RnHfId5ZCGRhKzPnQPbdAbdNd47TwsMeta || {},
    component: () => import("/app/pages/login.vue")
  },
  {
    name: "login___de",
    path: "/de/login",
    meta: loginKGJhNRZhH4FU_45RnHfId5ZCGRhKzPnQPbdAbdNd47TwsMeta || {},
    component: () => import("/app/pages/login.vue")
  },
  {
    name: "login___at",
    path: "/at/login",
    meta: loginKGJhNRZhH4FU_45RnHfId5ZCGRhKzPnQPbdAbdNd47TwsMeta || {},
    component: () => import("/app/pages/login.vue")
  },
  {
    name: "login___es",
    path: "/es/login",
    meta: loginKGJhNRZhH4FU_45RnHfId5ZCGRhKzPnQPbdAbdNd47TwsMeta || {},
    component: () => import("/app/pages/login.vue")
  },
  {
    name: "login___uk",
    path: "/uk/login",
    meta: loginKGJhNRZhH4FU_45RnHfId5ZCGRhKzPnQPbdAbdNd47TwsMeta || {},
    component: () => import("/app/pages/login.vue")
  },
  {
    name: "login___ru",
    path: "/ru/login",
    meta: loginKGJhNRZhH4FU_45RnHfId5ZCGRhKzPnQPbdAbdNd47TwsMeta || {},
    component: () => import("/app/pages/login.vue")
  },
  {
    name: "imprint___en___default",
    path: "/imprint",
    component: () => import("/app/pages/imprint.vue")
  },
  {
    name: "imprint___en",
    path: "/en/imprint",
    component: () => import("/app/pages/imprint.vue")
  },
  {
    name: "imprint___de",
    path: "/de/imprint",
    component: () => import("/app/pages/imprint.vue")
  },
  {
    name: "imprint___at",
    path: "/at/imprint",
    component: () => import("/app/pages/imprint.vue")
  },
  {
    name: "imprint___es",
    path: "/es/imprint",
    component: () => import("/app/pages/imprint.vue")
  },
  {
    name: "imprint___uk",
    path: "/uk/imprint",
    component: () => import("/app/pages/imprint.vue")
  },
  {
    name: "imprint___ru",
    path: "/ru/imprint",
    component: () => import("/app/pages/imprint.vue")
  },
  {
    name: "pricing___en___default",
    path: "/pricing",
    meta: pricingo1KWFKLyd5spZjtCwrwVvX23I_qnlyTFJchpkfnF_sUMeta || {},
    component: () => import("/app/pages/pricing.vue")
  },
  {
    name: "pricing___en",
    path: "/en/pricing",
    meta: pricingo1KWFKLyd5spZjtCwrwVvX23I_qnlyTFJchpkfnF_sUMeta || {},
    component: () => import("/app/pages/pricing.vue")
  },
  {
    name: "pricing___de",
    path: "/de/pricing",
    meta: pricingo1KWFKLyd5spZjtCwrwVvX23I_qnlyTFJchpkfnF_sUMeta || {},
    component: () => import("/app/pages/pricing.vue")
  },
  {
    name: "pricing___at",
    path: "/at/pricing",
    meta: pricingo1KWFKLyd5spZjtCwrwVvX23I_qnlyTFJchpkfnF_sUMeta || {},
    component: () => import("/app/pages/pricing.vue")
  },
  {
    name: "pricing___es",
    path: "/es/pricing",
    meta: pricingo1KWFKLyd5spZjtCwrwVvX23I_qnlyTFJchpkfnF_sUMeta || {},
    component: () => import("/app/pages/pricing.vue")
  },
  {
    name: "pricing___uk",
    path: "/uk/pricing",
    meta: pricingo1KWFKLyd5spZjtCwrwVvX23I_qnlyTFJchpkfnF_sUMeta || {},
    component: () => import("/app/pages/pricing.vue")
  },
  {
    name: "pricing___ru",
    path: "/ru/pricing",
    meta: pricingo1KWFKLyd5spZjtCwrwVvX23I_qnlyTFJchpkfnF_sUMeta || {},
    component: () => import("/app/pages/pricing.vue")
  },
  {
    name: "privacy___en___default",
    path: "/privacy",
    component: () => import("/app/pages/privacy.vue")
  },
  {
    name: "privacy___en",
    path: "/en/privacy",
    component: () => import("/app/pages/privacy.vue")
  },
  {
    name: "privacy___de",
    path: "/de/privacy",
    component: () => import("/app/pages/privacy.vue")
  },
  {
    name: "privacy___at",
    path: "/at/privacy",
    component: () => import("/app/pages/privacy.vue")
  },
  {
    name: "privacy___es",
    path: "/es/privacy",
    component: () => import("/app/pages/privacy.vue")
  },
  {
    name: "privacy___uk",
    path: "/uk/privacy",
    component: () => import("/app/pages/privacy.vue")
  },
  {
    name: "privacy___ru",
    path: "/ru/privacy",
    component: () => import("/app/pages/privacy.vue")
  },
  {
    name: "product___en___default",
    path: "/product",
    meta: product7MdlkxMtuBnvq2LPuiieYQHw9k_45XWBr4NXxwRdtRaM4Meta || {},
    component: () => import("/app/pages/product.vue")
  },
  {
    name: "product___en",
    path: "/en/product",
    meta: product7MdlkxMtuBnvq2LPuiieYQHw9k_45XWBr4NXxwRdtRaM4Meta || {},
    component: () => import("/app/pages/product.vue")
  },
  {
    name: "product___de",
    path: "/de/product",
    meta: product7MdlkxMtuBnvq2LPuiieYQHw9k_45XWBr4NXxwRdtRaM4Meta || {},
    component: () => import("/app/pages/product.vue")
  },
  {
    name: "product___at",
    path: "/at/product",
    meta: product7MdlkxMtuBnvq2LPuiieYQHw9k_45XWBr4NXxwRdtRaM4Meta || {},
    component: () => import("/app/pages/product.vue")
  },
  {
    name: "product___es",
    path: "/es/product",
    meta: product7MdlkxMtuBnvq2LPuiieYQHw9k_45XWBr4NXxwRdtRaM4Meta || {},
    component: () => import("/app/pages/product.vue")
  },
  {
    name: "product___uk",
    path: "/uk/product",
    meta: product7MdlkxMtuBnvq2LPuiieYQHw9k_45XWBr4NXxwRdtRaM4Meta || {},
    component: () => import("/app/pages/product.vue")
  },
  {
    name: "product___ru",
    path: "/ru/product",
    meta: product7MdlkxMtuBnvq2LPuiieYQHw9k_45XWBr4NXxwRdtRaM4Meta || {},
    component: () => import("/app/pages/product.vue")
  },
  {
    name: "features___en___default",
    path: "/features",
    meta: featuresCI_45NDYUfnZkzIjb1hcOQ3yLLEPvCItM1Aj7mxRKaacIMeta || {},
    component: () => import("/app/pages/features.vue")
  },
  {
    name: "features___en",
    path: "/en/features",
    meta: featuresCI_45NDYUfnZkzIjb1hcOQ3yLLEPvCItM1Aj7mxRKaacIMeta || {},
    component: () => import("/app/pages/features.vue")
  },
  {
    name: "features___de",
    path: "/de/features",
    meta: featuresCI_45NDYUfnZkzIjb1hcOQ3yLLEPvCItM1Aj7mxRKaacIMeta || {},
    component: () => import("/app/pages/features.vue")
  },
  {
    name: "features___at",
    path: "/at/features",
    meta: featuresCI_45NDYUfnZkzIjb1hcOQ3yLLEPvCItM1Aj7mxRKaacIMeta || {},
    component: () => import("/app/pages/features.vue")
  },
  {
    name: "features___es",
    path: "/es/features",
    meta: featuresCI_45NDYUfnZkzIjb1hcOQ3yLLEPvCItM1Aj7mxRKaacIMeta || {},
    component: () => import("/app/pages/features.vue")
  },
  {
    name: "features___uk",
    path: "/uk/features",
    meta: featuresCI_45NDYUfnZkzIjb1hcOQ3yLLEPvCItM1Aj7mxRKaacIMeta || {},
    component: () => import("/app/pages/features.vue")
  },
  {
    name: "features___ru",
    path: "/ru/features",
    meta: featuresCI_45NDYUfnZkzIjb1hcOQ3yLLEPvCItM1Aj7mxRKaacIMeta || {},
    component: () => import("/app/pages/features.vue")
  },
  {
    name: "register___en___default",
    path: "/register",
    meta: registerhhTixNN_gvg3OZSt2Nh0apJnSWfEASm8HSODFR1YEGYMeta || {},
    component: () => import("/app/pages/register.vue")
  },
  {
    name: "register___en",
    path: "/en/register",
    meta: registerhhTixNN_gvg3OZSt2Nh0apJnSWfEASm8HSODFR1YEGYMeta || {},
    component: () => import("/app/pages/register.vue")
  },
  {
    name: "register___de",
    path: "/de/register",
    meta: registerhhTixNN_gvg3OZSt2Nh0apJnSWfEASm8HSODFR1YEGYMeta || {},
    component: () => import("/app/pages/register.vue")
  },
  {
    name: "register___at",
    path: "/at/register",
    meta: registerhhTixNN_gvg3OZSt2Nh0apJnSWfEASm8HSODFR1YEGYMeta || {},
    component: () => import("/app/pages/register.vue")
  },
  {
    name: "register___es",
    path: "/es/register",
    meta: registerhhTixNN_gvg3OZSt2Nh0apJnSWfEASm8HSODFR1YEGYMeta || {},
    component: () => import("/app/pages/register.vue")
  },
  {
    name: "register___uk",
    path: "/uk/register",
    meta: registerhhTixNN_gvg3OZSt2Nh0apJnSWfEASm8HSODFR1YEGYMeta || {},
    component: () => import("/app/pages/register.vue")
  },
  {
    name: "register___ru",
    path: "/ru/register",
    meta: registerhhTixNN_gvg3OZSt2Nh0apJnSWfEASm8HSODFR1YEGYMeta || {},
    component: () => import("/app/pages/register.vue")
  },
  {
    name: "slug___en___default",
    path: "/:slug(.*)*",
    component: () => import("/app/pages/[...slug].vue")
  },
  {
    name: "slug___en",
    path: "/en/:slug(.*)*",
    component: () => import("/app/pages/[...slug].vue")
  },
  {
    name: "slug___de",
    path: "/de/:slug(.*)*",
    component: () => import("/app/pages/[...slug].vue")
  },
  {
    name: "slug___at",
    path: "/at/:slug(.*)*",
    component: () => import("/app/pages/[...slug].vue")
  },
  {
    name: "slug___es",
    path: "/es/:slug(.*)*",
    component: () => import("/app/pages/[...slug].vue")
  },
  {
    name: "slug___uk",
    path: "/uk/:slug(.*)*",
    component: () => import("/app/pages/[...slug].vue")
  },
  {
    name: "slug___ru",
    path: "/ru/:slug(.*)*",
    component: () => import("/app/pages/[...slug].vue")
  },
  {
    name: "warmingup___en___default",
    path: "/warmingup",
    component: () => import("/app/pages/warmingup.vue")
  },
  {
    name: "warmingup___en",
    path: "/en/warmingup",
    component: () => import("/app/pages/warmingup.vue")
  },
  {
    name: "warmingup___de",
    path: "/de/warmingup",
    component: () => import("/app/pages/warmingup.vue")
  },
  {
    name: "warmingup___at",
    path: "/at/warmingup",
    component: () => import("/app/pages/warmingup.vue")
  },
  {
    name: "warmingup___es",
    path: "/es/warmingup",
    component: () => import("/app/pages/warmingup.vue")
  },
  {
    name: "warmingup___uk",
    path: "/uk/warmingup",
    component: () => import("/app/pages/warmingup.vue")
  },
  {
    name: "warmingup___ru",
    path: "/ru/warmingup",
    component: () => import("/app/pages/warmingup.vue")
  },
  {
    name: "blog___en___default",
    path: "/blog",
    meta: indexXDrvC4X9cQh98rUTaKV7n9SAzKfJcTLnbJGv9g_YdesMeta || {},
    component: () => import("/app/pages/blog/index.vue")
  },
  {
    name: "blog___en",
    path: "/en/blog",
    meta: indexXDrvC4X9cQh98rUTaKV7n9SAzKfJcTLnbJGv9g_YdesMeta || {},
    component: () => import("/app/pages/blog/index.vue")
  },
  {
    name: "blog___de",
    path: "/de/blog",
    meta: indexXDrvC4X9cQh98rUTaKV7n9SAzKfJcTLnbJGv9g_YdesMeta || {},
    component: () => import("/app/pages/blog/index.vue")
  },
  {
    name: "blog___at",
    path: "/at/blog",
    meta: indexXDrvC4X9cQh98rUTaKV7n9SAzKfJcTLnbJGv9g_YdesMeta || {},
    component: () => import("/app/pages/blog/index.vue")
  },
  {
    name: "blog___es",
    path: "/es/blog",
    meta: indexXDrvC4X9cQh98rUTaKV7n9SAzKfJcTLnbJGv9g_YdesMeta || {},
    component: () => import("/app/pages/blog/index.vue")
  },
  {
    name: "blog___uk",
    path: "/uk/blog",
    meta: indexXDrvC4X9cQh98rUTaKV7n9SAzKfJcTLnbJGv9g_YdesMeta || {},
    component: () => import("/app/pages/blog/index.vue")
  },
  {
    name: "blog___ru",
    path: "/ru/blog",
    meta: indexXDrvC4X9cQh98rUTaKV7n9SAzKfJcTLnbJGv9g_YdesMeta || {},
    component: () => import("/app/pages/blog/index.vue")
  },
  {
    name: "home___en___default",
    path: "/home",
    component: () => import("/app/pages/home/index.vue")
  },
  {
    name: "home___en",
    path: "/en/home",
    component: () => import("/app/pages/home/index.vue")
  },
  {
    name: "home___de",
    path: "/de/home",
    component: () => import("/app/pages/home/index.vue")
  },
  {
    name: "home___at",
    path: "/at/home",
    component: () => import("/app/pages/home/index.vue")
  },
  {
    name: "home___es",
    path: "/es/home",
    component: () => import("/app/pages/home/index.vue")
  },
  {
    name: "home___uk",
    path: "/uk/home",
    component: () => import("/app/pages/home/index.vue")
  },
  {
    name: "home___ru",
    path: "/ru/home",
    component: () => import("/app/pages/home/index.vue")
  },
  {
    name: "wiki___en___default",
    path: "/wiki",
    meta: indexPyNEnibr09aLgqiv_45SpBIx0DO1WtxEmSAZ8_45j76P09oMeta || {},
    component: () => import("/app/pages/wiki/index.vue")
  },
  {
    name: "wiki___en",
    path: "/en/wiki",
    meta: indexPyNEnibr09aLgqiv_45SpBIx0DO1WtxEmSAZ8_45j76P09oMeta || {},
    component: () => import("/app/pages/wiki/index.vue")
  },
  {
    name: "wiki___de",
    path: "/de/wiki",
    meta: indexPyNEnibr09aLgqiv_45SpBIx0DO1WtxEmSAZ8_45j76P09oMeta || {},
    component: () => import("/app/pages/wiki/index.vue")
  },
  {
    name: "wiki___at",
    path: "/at/wiki",
    meta: indexPyNEnibr09aLgqiv_45SpBIx0DO1WtxEmSAZ8_45j76P09oMeta || {},
    component: () => import("/app/pages/wiki/index.vue")
  },
  {
    name: "wiki___es",
    path: "/es/wiki",
    meta: indexPyNEnibr09aLgqiv_45SpBIx0DO1WtxEmSAZ8_45j76P09oMeta || {},
    component: () => import("/app/pages/wiki/index.vue")
  },
  {
    name: "wiki___uk",
    path: "/uk/wiki",
    meta: indexPyNEnibr09aLgqiv_45SpBIx0DO1WtxEmSAZ8_45j76P09oMeta || {},
    component: () => import("/app/pages/wiki/index.vue")
  },
  {
    name: "wiki___ru",
    path: "/ru/wiki",
    meta: indexPyNEnibr09aLgqiv_45SpBIx0DO1WtxEmSAZ8_45j76P09oMeta || {},
    component: () => import("/app/pages/wiki/index.vue")
  },
  {
    name: "Tools___en___default",
    path: "/tools",
    meta: indexTGVRyIYXFCTpuXeAxrmeJ5DABJSwZkuf_45KtLwWt4pl0Meta || {},
    component: () => import("/app/pages/tools/index.vue")
  },
  {
    name: "Tools___en",
    path: "/en/tools",
    meta: indexTGVRyIYXFCTpuXeAxrmeJ5DABJSwZkuf_45KtLwWt4pl0Meta || {},
    component: () => import("/app/pages/tools/index.vue")
  },
  {
    name: "Tools___de",
    path: "/de/tools",
    meta: indexTGVRyIYXFCTpuXeAxrmeJ5DABJSwZkuf_45KtLwWt4pl0Meta || {},
    component: () => import("/app/pages/tools/index.vue")
  },
  {
    name: "Tools___at",
    path: "/at/tools",
    meta: indexTGVRyIYXFCTpuXeAxrmeJ5DABJSwZkuf_45KtLwWt4pl0Meta || {},
    component: () => import("/app/pages/tools/index.vue")
  },
  {
    name: "Tools___es",
    path: "/es/tools",
    meta: indexTGVRyIYXFCTpuXeAxrmeJ5DABJSwZkuf_45KtLwWt4pl0Meta || {},
    component: () => import("/app/pages/tools/index.vue")
  },
  {
    name: "Tools___uk",
    path: "/uk/tools",
    meta: indexTGVRyIYXFCTpuXeAxrmeJ5DABJSwZkuf_45KtLwWt4pl0Meta || {},
    component: () => import("/app/pages/tools/index.vue")
  },
  {
    name: "Tools___ru",
    path: "/ru/tools",
    meta: indexTGVRyIYXFCTpuXeAxrmeJ5DABJSwZkuf_45KtLwWt4pl0Meta || {},
    component: () => import("/app/pages/tools/index.vue")
  },
  {
    name: "cancellation___en___default",
    path: "/cancellation",
    component: () => import("/app/pages/cancellation.vue")
  },
  {
    name: "cancellation___en",
    path: "/en/cancellation",
    component: () => import("/app/pages/cancellation.vue")
  },
  {
    name: "cancellation___de",
    path: "/de/cancellation",
    component: () => import("/app/pages/cancellation.vue")
  },
  {
    name: "cancellation___at",
    path: "/at/cancellation",
    component: () => import("/app/pages/cancellation.vue")
  },
  {
    name: "cancellation___es",
    path: "/es/cancellation",
    component: () => import("/app/pages/cancellation.vue")
  },
  {
    name: "cancellation___uk",
    path: "/uk/cancellation",
    component: () => import("/app/pages/cancellation.vue")
  },
  {
    name: "cancellation___ru",
    path: "/ru/cancellation",
    component: () => import("/app/pages/cancellation.vue")
  },
  {
    name: "confirm-email___en___default",
    path: "/confirm-email",
    component: () => import("/app/pages/confirm-email.vue")
  },
  {
    name: "confirm-email___en",
    path: "/en/confirm-email",
    component: () => import("/app/pages/confirm-email.vue")
  },
  {
    name: "confirm-email___de",
    path: "/de/confirm-email",
    component: () => import("/app/pages/confirm-email.vue")
  },
  {
    name: "confirm-email___at",
    path: "/at/confirm-email",
    component: () => import("/app/pages/confirm-email.vue")
  },
  {
    name: "confirm-email___es",
    path: "/es/confirm-email",
    component: () => import("/app/pages/confirm-email.vue")
  },
  {
    name: "confirm-email___uk",
    path: "/uk/confirm-email",
    component: () => import("/app/pages/confirm-email.vue")
  },
  {
    name: "confirm-email___ru",
    path: "/ru/confirm-email",
    component: () => import("/app/pages/confirm-email.vue")
  },
  {
    name: settingsjVeY63OdxoPmKajnN2v_45iXJDIPUjqn2x3IvdE5CApQsMeta?.name,
    path: "/home/settings",
    meta: settingsjVeY63OdxoPmKajnN2v_45iXJDIPUjqn2x3IvdE5CApQsMeta || {},
    component: () => import("/app/pages/home/settings.vue"),
    children: [
  {
    name: "home-settings___en___default",
    path: "",
    component: () => import("/app/pages/home/settings/index.vue")
  },
  {
    name: "home-settings-theme___en___default",
    path: "theme",
    component: () => import("/app/pages/home/settings/theme.vue")
  },
  {
    name: "home-settings-account___en___default",
    path: "account",
    component: () => import("/app/pages/home/settings/account.vue")
  },
  {
    name: "home-settings-affiliates___en___default",
    path: "affiliates",
    component: () => import("/app/pages/home/settings/affiliates.vue")
  },
  {
    name: "home-settings-admin-blogs___en___default",
    path: "admin/blogs",
    component: () => import("/app/pages/home/settings/admin/blogs.vue")
  },
  {
    name: "home-settings-admin-roles___en___default",
    path: "admin/roles",
    component: () => import("/app/pages/home/settings/admin/roles.vue")
  },
  {
    name: "home-settings-admin-users___en___default",
    path: "admin/users",
    component: () => import("/app/pages/home/settings/admin/users.vue")
  },
  {
    name: "home-settings-flightschool___en___default",
    path: "flightschool",
    meta: flightschool9wh7iopRIf3HKCmXLf6G1XlgQ_45_45_s0GEf65sl_45_45tS_QMeta || {},
    component: () => import("/app/pages/home/settings/flightschool.vue")
  },
  {
    name: "home-settings-notifications___en___default",
    path: "notifications",
    component: () => import("/app/pages/home/settings/notifications.vue")
  },
  {
    name: "home-settings-subscriptions___en___default",
    path: "subscriptions",
    component: () => import("/app/pages/home/settings/subscriptions.vue")
  },
  {
    name: "home-settings-admin-scenarios___en___default",
    path: "admin/scenarios",
    component: () => import("/app/pages/home/settings/admin/scenarios.vue")
  },
  {
    name: "home-settings-payment-methods___en___default",
    path: "payment-methods",
    component: () => import("/app/pages/home/settings/payment-methods.vue")
  },
  {
    name: "home-settings-admin-activities___en___default",
    path: "admin/activities",
    component: () => import("/app/pages/home/settings/admin/activities.vue")
  },
  {
    name: "home-settings-admin-transmissions___en___default",
    path: "admin/transmissions",
    component: () => import("/app/pages/home/settings/admin/transmissions.vue")
  }
]
  },
  {
    name: settingsjVeY63OdxoPmKajnN2v_45iXJDIPUjqn2x3IvdE5CApQsMeta?.name,
    path: "/en/home/settings",
    meta: settingsjVeY63OdxoPmKajnN2v_45iXJDIPUjqn2x3IvdE5CApQsMeta || {},
    component: () => import("/app/pages/home/settings.vue"),
    children: [
  {
    name: "home-settings___en",
    path: "",
    component: () => import("/app/pages/home/settings/index.vue")
  },
  {
    name: "home-settings-theme___en",
    path: "theme",
    component: () => import("/app/pages/home/settings/theme.vue")
  },
  {
    name: "home-settings-account___en",
    path: "account",
    component: () => import("/app/pages/home/settings/account.vue")
  },
  {
    name: "home-settings-affiliates___en",
    path: "affiliates",
    component: () => import("/app/pages/home/settings/affiliates.vue")
  },
  {
    name: "home-settings-admin-blogs___en",
    path: "admin/blogs",
    component: () => import("/app/pages/home/settings/admin/blogs.vue")
  },
  {
    name: "home-settings-admin-roles___en",
    path: "admin/roles",
    component: () => import("/app/pages/home/settings/admin/roles.vue")
  },
  {
    name: "home-settings-admin-users___en",
    path: "admin/users",
    component: () => import("/app/pages/home/settings/admin/users.vue")
  },
  {
    name: "home-settings-flightschool___en",
    path: "flightschool",
    meta: flightschool9wh7iopRIf3HKCmXLf6G1XlgQ_45_45_s0GEf65sl_45_45tS_QMeta || {},
    component: () => import("/app/pages/home/settings/flightschool.vue")
  },
  {
    name: "home-settings-notifications___en",
    path: "notifications",
    component: () => import("/app/pages/home/settings/notifications.vue")
  },
  {
    name: "home-settings-subscriptions___en",
    path: "subscriptions",
    component: () => import("/app/pages/home/settings/subscriptions.vue")
  },
  {
    name: "home-settings-admin-scenarios___en",
    path: "admin/scenarios",
    component: () => import("/app/pages/home/settings/admin/scenarios.vue")
  },
  {
    name: "home-settings-payment-methods___en",
    path: "payment-methods",
    component: () => import("/app/pages/home/settings/payment-methods.vue")
  },
  {
    name: "home-settings-admin-activities___en",
    path: "admin/activities",
    component: () => import("/app/pages/home/settings/admin/activities.vue")
  },
  {
    name: "home-settings-admin-transmissions___en",
    path: "admin/transmissions",
    component: () => import("/app/pages/home/settings/admin/transmissions.vue")
  }
]
  },
  {
    name: settingsjVeY63OdxoPmKajnN2v_45iXJDIPUjqn2x3IvdE5CApQsMeta?.name,
    path: "/de/home/settings",
    meta: settingsjVeY63OdxoPmKajnN2v_45iXJDIPUjqn2x3IvdE5CApQsMeta || {},
    component: () => import("/app/pages/home/settings.vue"),
    children: [
  {
    name: "home-settings___de",
    path: "",
    component: () => import("/app/pages/home/settings/index.vue")
  },
  {
    name: "home-settings-theme___de",
    path: "theme",
    component: () => import("/app/pages/home/settings/theme.vue")
  },
  {
    name: "home-settings-account___de",
    path: "account",
    component: () => import("/app/pages/home/settings/account.vue")
  },
  {
    name: "home-settings-affiliates___de",
    path: "affiliates",
    component: () => import("/app/pages/home/settings/affiliates.vue")
  },
  {
    name: "home-settings-admin-blogs___de",
    path: "admin/blogs",
    component: () => import("/app/pages/home/settings/admin/blogs.vue")
  },
  {
    name: "home-settings-admin-roles___de",
    path: "admin/roles",
    component: () => import("/app/pages/home/settings/admin/roles.vue")
  },
  {
    name: "home-settings-admin-users___de",
    path: "admin/users",
    component: () => import("/app/pages/home/settings/admin/users.vue")
  },
  {
    name: "home-settings-flightschool___de",
    path: "flightschool",
    meta: flightschool9wh7iopRIf3HKCmXLf6G1XlgQ_45_45_s0GEf65sl_45_45tS_QMeta || {},
    component: () => import("/app/pages/home/settings/flightschool.vue")
  },
  {
    name: "home-settings-notifications___de",
    path: "notifications",
    component: () => import("/app/pages/home/settings/notifications.vue")
  },
  {
    name: "home-settings-subscriptions___de",
    path: "subscriptions",
    component: () => import("/app/pages/home/settings/subscriptions.vue")
  },
  {
    name: "home-settings-admin-scenarios___de",
    path: "admin/scenarios",
    component: () => import("/app/pages/home/settings/admin/scenarios.vue")
  },
  {
    name: "home-settings-payment-methods___de",
    path: "payment-methods",
    component: () => import("/app/pages/home/settings/payment-methods.vue")
  },
  {
    name: "home-settings-admin-activities___de",
    path: "admin/activities",
    component: () => import("/app/pages/home/settings/admin/activities.vue")
  },
  {
    name: "home-settings-admin-transmissions___de",
    path: "admin/transmissions",
    component: () => import("/app/pages/home/settings/admin/transmissions.vue")
  }
]
  },
  {
    name: settingsjVeY63OdxoPmKajnN2v_45iXJDIPUjqn2x3IvdE5CApQsMeta?.name,
    path: "/at/home/settings",
    meta: settingsjVeY63OdxoPmKajnN2v_45iXJDIPUjqn2x3IvdE5CApQsMeta || {},
    component: () => import("/app/pages/home/settings.vue"),
    children: [
  {
    name: "home-settings___at",
    path: "",
    component: () => import("/app/pages/home/settings/index.vue")
  },
  {
    name: "home-settings-theme___at",
    path: "theme",
    component: () => import("/app/pages/home/settings/theme.vue")
  },
  {
    name: "home-settings-account___at",
    path: "account",
    component: () => import("/app/pages/home/settings/account.vue")
  },
  {
    name: "home-settings-affiliates___at",
    path: "affiliates",
    component: () => import("/app/pages/home/settings/affiliates.vue")
  },
  {
    name: "home-settings-admin-blogs___at",
    path: "admin/blogs",
    component: () => import("/app/pages/home/settings/admin/blogs.vue")
  },
  {
    name: "home-settings-admin-roles___at",
    path: "admin/roles",
    component: () => import("/app/pages/home/settings/admin/roles.vue")
  },
  {
    name: "home-settings-admin-users___at",
    path: "admin/users",
    component: () => import("/app/pages/home/settings/admin/users.vue")
  },
  {
    name: "home-settings-flightschool___at",
    path: "flightschool",
    meta: flightschool9wh7iopRIf3HKCmXLf6G1XlgQ_45_45_s0GEf65sl_45_45tS_QMeta || {},
    component: () => import("/app/pages/home/settings/flightschool.vue")
  },
  {
    name: "home-settings-notifications___at",
    path: "notifications",
    component: () => import("/app/pages/home/settings/notifications.vue")
  },
  {
    name: "home-settings-subscriptions___at",
    path: "subscriptions",
    component: () => import("/app/pages/home/settings/subscriptions.vue")
  },
  {
    name: "home-settings-admin-scenarios___at",
    path: "admin/scenarios",
    component: () => import("/app/pages/home/settings/admin/scenarios.vue")
  },
  {
    name: "home-settings-payment-methods___at",
    path: "payment-methods",
    component: () => import("/app/pages/home/settings/payment-methods.vue")
  },
  {
    name: "home-settings-admin-activities___at",
    path: "admin/activities",
    component: () => import("/app/pages/home/settings/admin/activities.vue")
  },
  {
    name: "home-settings-admin-transmissions___at",
    path: "admin/transmissions",
    component: () => import("/app/pages/home/settings/admin/transmissions.vue")
  }
]
  },
  {
    name: settingsjVeY63OdxoPmKajnN2v_45iXJDIPUjqn2x3IvdE5CApQsMeta?.name,
    path: "/es/home/settings",
    meta: settingsjVeY63OdxoPmKajnN2v_45iXJDIPUjqn2x3IvdE5CApQsMeta || {},
    component: () => import("/app/pages/home/settings.vue"),
    children: [
  {
    name: "home-settings___es",
    path: "",
    component: () => import("/app/pages/home/settings/index.vue")
  },
  {
    name: "home-settings-theme___es",
    path: "theme",
    component: () => import("/app/pages/home/settings/theme.vue")
  },
  {
    name: "home-settings-account___es",
    path: "account",
    component: () => import("/app/pages/home/settings/account.vue")
  },
  {
    name: "home-settings-affiliates___es",
    path: "affiliates",
    component: () => import("/app/pages/home/settings/affiliates.vue")
  },
  {
    name: "home-settings-admin-blogs___es",
    path: "admin/blogs",
    component: () => import("/app/pages/home/settings/admin/blogs.vue")
  },
  {
    name: "home-settings-admin-roles___es",
    path: "admin/roles",
    component: () => import("/app/pages/home/settings/admin/roles.vue")
  },
  {
    name: "home-settings-admin-users___es",
    path: "admin/users",
    component: () => import("/app/pages/home/settings/admin/users.vue")
  },
  {
    name: "home-settings-flightschool___es",
    path: "flightschool",
    meta: flightschool9wh7iopRIf3HKCmXLf6G1XlgQ_45_45_s0GEf65sl_45_45tS_QMeta || {},
    component: () => import("/app/pages/home/settings/flightschool.vue")
  },
  {
    name: "home-settings-notifications___es",
    path: "notifications",
    component: () => import("/app/pages/home/settings/notifications.vue")
  },
  {
    name: "home-settings-subscriptions___es",
    path: "subscriptions",
    component: () => import("/app/pages/home/settings/subscriptions.vue")
  },
  {
    name: "home-settings-admin-scenarios___es",
    path: "admin/scenarios",
    component: () => import("/app/pages/home/settings/admin/scenarios.vue")
  },
  {
    name: "home-settings-payment-methods___es",
    path: "payment-methods",
    component: () => import("/app/pages/home/settings/payment-methods.vue")
  },
  {
    name: "home-settings-admin-activities___es",
    path: "admin/activities",
    component: () => import("/app/pages/home/settings/admin/activities.vue")
  },
  {
    name: "home-settings-admin-transmissions___es",
    path: "admin/transmissions",
    component: () => import("/app/pages/home/settings/admin/transmissions.vue")
  }
]
  },
  {
    name: settingsjVeY63OdxoPmKajnN2v_45iXJDIPUjqn2x3IvdE5CApQsMeta?.name,
    path: "/uk/home/settings",
    meta: settingsjVeY63OdxoPmKajnN2v_45iXJDIPUjqn2x3IvdE5CApQsMeta || {},
    component: () => import("/app/pages/home/settings.vue"),
    children: [
  {
    name: "home-settings___uk",
    path: "",
    component: () => import("/app/pages/home/settings/index.vue")
  },
  {
    name: "home-settings-theme___uk",
    path: "theme",
    component: () => import("/app/pages/home/settings/theme.vue")
  },
  {
    name: "home-settings-account___uk",
    path: "account",
    component: () => import("/app/pages/home/settings/account.vue")
  },
  {
    name: "home-settings-affiliates___uk",
    path: "affiliates",
    component: () => import("/app/pages/home/settings/affiliates.vue")
  },
  {
    name: "home-settings-admin-blogs___uk",
    path: "admin/blogs",
    component: () => import("/app/pages/home/settings/admin/blogs.vue")
  },
  {
    name: "home-settings-admin-roles___uk",
    path: "admin/roles",
    component: () => import("/app/pages/home/settings/admin/roles.vue")
  },
  {
    name: "home-settings-admin-users___uk",
    path: "admin/users",
    component: () => import("/app/pages/home/settings/admin/users.vue")
  },
  {
    name: "home-settings-flightschool___uk",
    path: "flightschool",
    meta: flightschool9wh7iopRIf3HKCmXLf6G1XlgQ_45_45_s0GEf65sl_45_45tS_QMeta || {},
    component: () => import("/app/pages/home/settings/flightschool.vue")
  },
  {
    name: "home-settings-notifications___uk",
    path: "notifications",
    component: () => import("/app/pages/home/settings/notifications.vue")
  },
  {
    name: "home-settings-subscriptions___uk",
    path: "subscriptions",
    component: () => import("/app/pages/home/settings/subscriptions.vue")
  },
  {
    name: "home-settings-admin-scenarios___uk",
    path: "admin/scenarios",
    component: () => import("/app/pages/home/settings/admin/scenarios.vue")
  },
  {
    name: "home-settings-payment-methods___uk",
    path: "payment-methods",
    component: () => import("/app/pages/home/settings/payment-methods.vue")
  },
  {
    name: "home-settings-admin-activities___uk",
    path: "admin/activities",
    component: () => import("/app/pages/home/settings/admin/activities.vue")
  },
  {
    name: "home-settings-admin-transmissions___uk",
    path: "admin/transmissions",
    component: () => import("/app/pages/home/settings/admin/transmissions.vue")
  }
]
  },
  {
    name: settingsjVeY63OdxoPmKajnN2v_45iXJDIPUjqn2x3IvdE5CApQsMeta?.name,
    path: "/ru/home/settings",
    meta: settingsjVeY63OdxoPmKajnN2v_45iXJDIPUjqn2x3IvdE5CApQsMeta || {},
    component: () => import("/app/pages/home/settings.vue"),
    children: [
  {
    name: "home-settings___ru",
    path: "",
    component: () => import("/app/pages/home/settings/index.vue")
  },
  {
    name: "home-settings-theme___ru",
    path: "theme",
    component: () => import("/app/pages/home/settings/theme.vue")
  },
  {
    name: "home-settings-account___ru",
    path: "account",
    component: () => import("/app/pages/home/settings/account.vue")
  },
  {
    name: "home-settings-affiliates___ru",
    path: "affiliates",
    component: () => import("/app/pages/home/settings/affiliates.vue")
  },
  {
    name: "home-settings-admin-blogs___ru",
    path: "admin/blogs",
    component: () => import("/app/pages/home/settings/admin/blogs.vue")
  },
  {
    name: "home-settings-admin-roles___ru",
    path: "admin/roles",
    component: () => import("/app/pages/home/settings/admin/roles.vue")
  },
  {
    name: "home-settings-admin-users___ru",
    path: "admin/users",
    component: () => import("/app/pages/home/settings/admin/users.vue")
  },
  {
    name: "home-settings-flightschool___ru",
    path: "flightschool",
    meta: flightschool9wh7iopRIf3HKCmXLf6G1XlgQ_45_45_s0GEf65sl_45_45tS_QMeta || {},
    component: () => import("/app/pages/home/settings/flightschool.vue")
  },
  {
    name: "home-settings-notifications___ru",
    path: "notifications",
    component: () => import("/app/pages/home/settings/notifications.vue")
  },
  {
    name: "home-settings-subscriptions___ru",
    path: "subscriptions",
    component: () => import("/app/pages/home/settings/subscriptions.vue")
  },
  {
    name: "home-settings-admin-scenarios___ru",
    path: "admin/scenarios",
    component: () => import("/app/pages/home/settings/admin/scenarios.vue")
  },
  {
    name: "home-settings-payment-methods___ru",
    path: "payment-methods",
    component: () => import("/app/pages/home/settings/payment-methods.vue")
  },
  {
    name: "home-settings-admin-activities___ru",
    path: "admin/activities",
    component: () => import("/app/pages/home/settings/admin/activities.vue")
  },
  {
    name: "home-settings-admin-transmissions___ru",
    path: "admin/transmissions",
    component: () => import("/app/pages/home/settings/admin/transmissions.vue")
  }
]
  },
  {
    name: "forgot-password___en___default",
    path: "/forgot-password",
    meta: forgot_45passwordgdzNcmliYSc_RqJLDFi4QKABybrSV1OTdLl0SK_45V07UMeta || {},
    component: () => import("/app/pages/forgot-password.vue")
  },
  {
    name: "forgot-password___en",
    path: "/en/forgot-password",
    meta: forgot_45passwordgdzNcmliYSc_RqJLDFi4QKABybrSV1OTdLl0SK_45V07UMeta || {},
    component: () => import("/app/pages/forgot-password.vue")
  },
  {
    name: "forgot-password___de",
    path: "/de/forgot-password",
    meta: forgot_45passwordgdzNcmliYSc_RqJLDFi4QKABybrSV1OTdLl0SK_45V07UMeta || {},
    component: () => import("/app/pages/forgot-password.vue")
  },
  {
    name: "forgot-password___at",
    path: "/at/forgot-password",
    meta: forgot_45passwordgdzNcmliYSc_RqJLDFi4QKABybrSV1OTdLl0SK_45V07UMeta || {},
    component: () => import("/app/pages/forgot-password.vue")
  },
  {
    name: "forgot-password___es",
    path: "/es/forgot-password",
    meta: forgot_45passwordgdzNcmliYSc_RqJLDFi4QKABybrSV1OTdLl0SK_45V07UMeta || {},
    component: () => import("/app/pages/forgot-password.vue")
  },
  {
    name: "forgot-password___uk",
    path: "/uk/forgot-password",
    meta: forgot_45passwordgdzNcmliYSc_RqJLDFi4QKABybrSV1OTdLl0SK_45V07UMeta || {},
    component: () => import("/app/pages/forgot-password.vue")
  },
  {
    name: "forgot-password___ru",
    path: "/ru/forgot-password",
    meta: forgot_45passwordgdzNcmliYSc_RqJLDFi4QKABybrSV1OTdLl0SK_45V07UMeta || {},
    component: () => import("/app/pages/forgot-password.vue")
  },
  {
    name: "wiki-procedures___en___default",
    path: "/wiki/procedures",
    component: () => import("/app/pages/wiki/procedures.vue")
  },
  {
    name: "wiki-procedures___en",
    path: "/en/wiki/procedures",
    component: () => import("/app/pages/wiki/procedures.vue")
  },
  {
    name: "wiki-procedures___de",
    path: "/de/wiki/procedures",
    component: () => import("/app/pages/wiki/procedures.vue")
  },
  {
    name: "wiki-procedures___at",
    path: "/at/wiki/procedures",
    component: () => import("/app/pages/wiki/procedures.vue")
  },
  {
    name: "wiki-procedures___es",
    path: "/es/wiki/procedures",
    component: () => import("/app/pages/wiki/procedures.vue")
  },
  {
    name: "wiki-procedures___uk",
    path: "/uk/wiki/procedures",
    component: () => import("/app/pages/wiki/procedures.vue")
  },
  {
    name: "wiki-procedures___ru",
    path: "/ru/wiki/procedures",
    component: () => import("/app/pages/wiki/procedures.vue")
  },
  {
    name: "home-school___en___default",
    path: "/home/school",
    component: () => import("/app/pages/home/school/index.vue")
  },
  {
    name: "home-school___en",
    path: "/en/home/school",
    component: () => import("/app/pages/home/school/index.vue")
  },
  {
    name: "home-school___de",
    path: "/de/home/school",
    component: () => import("/app/pages/home/school/index.vue")
  },
  {
    name: "home-school___at",
    path: "/at/home/school",
    component: () => import("/app/pages/home/school/index.vue")
  },
  {
    name: "home-school___es",
    path: "/es/home/school",
    component: () => import("/app/pages/home/school/index.vue")
  },
  {
    name: "home-school___uk",
    path: "/uk/home/school",
    component: () => import("/app/pages/home/school/index.vue")
  },
  {
    name: "home-school___ru",
    path: "/ru/home/school",
    component: () => import("/app/pages/home/school/index.vue")
  },
  {
    name: "home-complete-setup___en___default",
    path: "/home/complete-setup",
    meta: complete_45setupz_JioV9DqbWWOR_45ufF_45WOJQydUteCUeQboa3pj38K5MMeta || {},
    component: () => import("/app/pages/home/complete-setup.vue")
  },
  {
    name: "home-complete-setup___en",
    path: "/en/home/complete-setup",
    meta: complete_45setupz_JioV9DqbWWOR_45ufF_45WOJQydUteCUeQboa3pj38K5MMeta || {},
    component: () => import("/app/pages/home/complete-setup.vue")
  },
  {
    name: "home-complete-setup___de",
    path: "/de/home/complete-setup",
    meta: complete_45setupz_JioV9DqbWWOR_45ufF_45WOJQydUteCUeQboa3pj38K5MMeta || {},
    component: () => import("/app/pages/home/complete-setup.vue")
  },
  {
    name: "home-complete-setup___at",
    path: "/at/home/complete-setup",
    meta: complete_45setupz_JioV9DqbWWOR_45ufF_45WOJQydUteCUeQboa3pj38K5MMeta || {},
    component: () => import("/app/pages/home/complete-setup.vue")
  },
  {
    name: "home-complete-setup___es",
    path: "/es/home/complete-setup",
    meta: complete_45setupz_JioV9DqbWWOR_45ufF_45WOJQydUteCUeQboa3pj38K5MMeta || {},
    component: () => import("/app/pages/home/complete-setup.vue")
  },
  {
    name: "home-complete-setup___uk",
    path: "/uk/home/complete-setup",
    meta: complete_45setupz_JioV9DqbWWOR_45ufF_45WOJQydUteCUeQboa3pj38K5MMeta || {},
    component: () => import("/app/pages/home/complete-setup.vue")
  },
  {
    name: "home-complete-setup___ru",
    path: "/ru/home/complete-setup",
    meta: complete_45setupz_JioV9DqbWWOR_45ufF_45WOJQydUteCUeQboa3pj38K5MMeta || {},
    component: () => import("/app/pages/home/complete-setup.vue")
  },
  {
    name: "home-school-courses___en___default",
    path: "/home/school/courses",
    meta: coursess2NmmdsfCaGv12LmEFn3VUzMP6o6Vmhi5qHyugaPVHQMeta || {},
    component: () => import("/app/pages/home/school/courses.vue")
  },
  {
    name: "home-school-courses___en",
    path: "/en/home/school/courses",
    meta: coursess2NmmdsfCaGv12LmEFn3VUzMP6o6Vmhi5qHyugaPVHQMeta || {},
    component: () => import("/app/pages/home/school/courses.vue")
  },
  {
    name: "home-school-courses___de",
    path: "/de/home/school/courses",
    meta: coursess2NmmdsfCaGv12LmEFn3VUzMP6o6Vmhi5qHyugaPVHQMeta || {},
    component: () => import("/app/pages/home/school/courses.vue")
  },
  {
    name: "home-school-courses___at",
    path: "/at/home/school/courses",
    meta: coursess2NmmdsfCaGv12LmEFn3VUzMP6o6Vmhi5qHyugaPVHQMeta || {},
    component: () => import("/app/pages/home/school/courses.vue")
  },
  {
    name: "home-school-courses___es",
    path: "/es/home/school/courses",
    meta: coursess2NmmdsfCaGv12LmEFn3VUzMP6o6Vmhi5qHyugaPVHQMeta || {},
    component: () => import("/app/pages/home/school/courses.vue")
  },
  {
    name: "home-school-courses___uk",
    path: "/uk/home/school/courses",
    meta: coursess2NmmdsfCaGv12LmEFn3VUzMP6o6Vmhi5qHyugaPVHQMeta || {},
    component: () => import("/app/pages/home/school/courses.vue")
  },
  {
    name: "home-school-courses___ru",
    path: "/ru/home/school/courses",
    meta: coursess2NmmdsfCaGv12LmEFn3VUzMP6o6Vmhi5qHyugaPVHQMeta || {},
    component: () => import("/app/pages/home/school/courses.vue")
  },
  {
    name: "home-school-simulator___en___default",
    path: "/home/school/simulator",
    meta: simulatorOnBuwF9qRw_on8VZhqCqMBp5eN2JHQS4EtEGZillp1cMeta || {},
    component: () => import("/app/pages/home/school/simulator.vue")
  },
  {
    name: "home-school-simulator___en",
    path: "/en/home/school/simulator",
    meta: simulatorOnBuwF9qRw_on8VZhqCqMBp5eN2JHQS4EtEGZillp1cMeta || {},
    component: () => import("/app/pages/home/school/simulator.vue")
  },
  {
    name: "home-school-simulator___de",
    path: "/de/home/school/simulator",
    meta: simulatorOnBuwF9qRw_on8VZhqCqMBp5eN2JHQS4EtEGZillp1cMeta || {},
    component: () => import("/app/pages/home/school/simulator.vue")
  },
  {
    name: "home-school-simulator___at",
    path: "/at/home/school/simulator",
    meta: simulatorOnBuwF9qRw_on8VZhqCqMBp5eN2JHQS4EtEGZillp1cMeta || {},
    component: () => import("/app/pages/home/school/simulator.vue")
  },
  {
    name: "home-school-simulator___es",
    path: "/es/home/school/simulator",
    meta: simulatorOnBuwF9qRw_on8VZhqCqMBp5eN2JHQS4EtEGZillp1cMeta || {},
    component: () => import("/app/pages/home/school/simulator.vue")
  },
  {
    name: "home-school-simulator___uk",
    path: "/uk/home/school/simulator",
    meta: simulatorOnBuwF9qRw_on8VZhqCqMBp5eN2JHQS4EtEGZillp1cMeta || {},
    component: () => import("/app/pages/home/school/simulator.vue")
  },
  {
    name: "home-school-simulator___ru",
    path: "/ru/home/school/simulator",
    meta: simulatorOnBuwF9qRw_on8VZhqCqMBp5eN2JHQS4EtEGZillp1cMeta || {},
    component: () => import("/app/pages/home/school/simulator.vue")
  },
  {
    name: "profile-username___en___default",
    path: "/profile/:username(.*)*",
    meta: _91_46_46_46username_93_cghJM4U8ZqjGBHdxtt920persmljFR9OIu4xvYTVYcMeta || {},
    component: () => import("/app/pages/profile/[...username].vue")
  },
  {
    name: "profile-username___en",
    path: "/en/profile/:username(.*)*",
    meta: _91_46_46_46username_93_cghJM4U8ZqjGBHdxtt920persmljFR9OIu4xvYTVYcMeta || {},
    component: () => import("/app/pages/profile/[...username].vue")
  },
  {
    name: "profile-username___de",
    path: "/de/profile/:username(.*)*",
    meta: _91_46_46_46username_93_cghJM4U8ZqjGBHdxtt920persmljFR9OIu4xvYTVYcMeta || {},
    component: () => import("/app/pages/profile/[...username].vue")
  },
  {
    name: "profile-username___at",
    path: "/at/profile/:username(.*)*",
    meta: _91_46_46_46username_93_cghJM4U8ZqjGBHdxtt920persmljFR9OIu4xvYTVYcMeta || {},
    component: () => import("/app/pages/profile/[...username].vue")
  },
  {
    name: "profile-username___es",
    path: "/es/profile/:username(.*)*",
    meta: _91_46_46_46username_93_cghJM4U8ZqjGBHdxtt920persmljFR9OIu4xvYTVYcMeta || {},
    component: () => import("/app/pages/profile/[...username].vue")
  },
  {
    name: "profile-username___uk",
    path: "/uk/profile/:username(.*)*",
    meta: _91_46_46_46username_93_cghJM4U8ZqjGBHdxtt920persmljFR9OIu4xvYTVYcMeta || {},
    component: () => import("/app/pages/profile/[...username].vue")
  },
  {
    name: "profile-username___ru",
    path: "/ru/profile/:username(.*)*",
    meta: _91_46_46_46username_93_cghJM4U8ZqjGBHdxtt920persmljFR9OIu4xvYTVYcMeta || {},
    component: () => import("/app/pages/profile/[...username].vue")
  },
  {
    name: "tools-aerodrome___en___default",
    path: "/tools/aerodrome",
    meta: indextPOgS5yRV0RoUcrkCyWuNETYYU2X5LEBfcQBOOfqznIMeta || {},
    component: () => import("/app/pages/tools/aerodrome/index.vue")
  },
  {
    name: "tools-aerodrome___en",
    path: "/en/tools/aerodrome",
    meta: indextPOgS5yRV0RoUcrkCyWuNETYYU2X5LEBfcQBOOfqznIMeta || {},
    component: () => import("/app/pages/tools/aerodrome/index.vue")
  },
  {
    name: "tools-aerodrome___de",
    path: "/de/tools/aerodrome",
    meta: indextPOgS5yRV0RoUcrkCyWuNETYYU2X5LEBfcQBOOfqznIMeta || {},
    component: () => import("/app/pages/tools/aerodrome/index.vue")
  },
  {
    name: "tools-aerodrome___at",
    path: "/at/tools/aerodrome",
    meta: indextPOgS5yRV0RoUcrkCyWuNETYYU2X5LEBfcQBOOfqznIMeta || {},
    component: () => import("/app/pages/tools/aerodrome/index.vue")
  },
  {
    name: "tools-aerodrome___es",
    path: "/es/tools/aerodrome",
    meta: indextPOgS5yRV0RoUcrkCyWuNETYYU2X5LEBfcQBOOfqznIMeta || {},
    component: () => import("/app/pages/tools/aerodrome/index.vue")
  },
  {
    name: "tools-aerodrome___uk",
    path: "/uk/tools/aerodrome",
    meta: indextPOgS5yRV0RoUcrkCyWuNETYYU2X5LEBfcQBOOfqznIMeta || {},
    component: () => import("/app/pages/tools/aerodrome/index.vue")
  },
  {
    name: "tools-aerodrome___ru",
    path: "/ru/tools/aerodrome",
    meta: indextPOgS5yRV0RoUcrkCyWuNETYYU2X5LEBfcQBOOfqznIMeta || {},
    component: () => import("/app/pages/tools/aerodrome/index.vue")
  },
  {
    name: "tools-frequency___en___default",
    path: "/tools/frequency",
    meta: indexZvlKJBrQa_nID3dzmlvyEnYSNeo0HtJipMaPpwPdqxQMeta || {},
    component: () => import("/app/pages/tools/frequency/index.vue")
  },
  {
    name: "tools-frequency___en",
    path: "/en/tools/frequency",
    meta: indexZvlKJBrQa_nID3dzmlvyEnYSNeo0HtJipMaPpwPdqxQMeta || {},
    component: () => import("/app/pages/tools/frequency/index.vue")
  },
  {
    name: "tools-frequency___de",
    path: "/de/tools/frequency",
    meta: indexZvlKJBrQa_nID3dzmlvyEnYSNeo0HtJipMaPpwPdqxQMeta || {},
    component: () => import("/app/pages/tools/frequency/index.vue")
  },
  {
    name: "tools-frequency___at",
    path: "/at/tools/frequency",
    meta: indexZvlKJBrQa_nID3dzmlvyEnYSNeo0HtJipMaPpwPdqxQMeta || {},
    component: () => import("/app/pages/tools/frequency/index.vue")
  },
  {
    name: "tools-frequency___es",
    path: "/es/tools/frequency",
    meta: indexZvlKJBrQa_nID3dzmlvyEnYSNeo0HtJipMaPpwPdqxQMeta || {},
    component: () => import("/app/pages/tools/frequency/index.vue")
  },
  {
    name: "tools-frequency___uk",
    path: "/uk/tools/frequency",
    meta: indexZvlKJBrQa_nID3dzmlvyEnYSNeo0HtJipMaPpwPdqxQMeta || {},
    component: () => import("/app/pages/tools/frequency/index.vue")
  },
  {
    name: "tools-frequency___ru",
    path: "/ru/tools/frequency",
    meta: indexZvlKJBrQa_nID3dzmlvyEnYSNeo0HtJipMaPpwPdqxQMeta || {},
    component: () => import("/app/pages/tools/frequency/index.vue")
  },
  {
    name: "tools-aerodrome-icao___en___default",
    path: "/tools/aerodrome/:icao()",
    component: () => import("/app/pages/tools/aerodrome/[icao].vue")
  },
  {
    name: "tools-aerodrome-icao___en",
    path: "/en/tools/aerodrome/:icao()",
    component: () => import("/app/pages/tools/aerodrome/[icao].vue")
  },
  {
    name: "tools-aerodrome-icao___de",
    path: "/de/tools/aerodrome/:icao()",
    component: () => import("/app/pages/tools/aerodrome/[icao].vue")
  },
  {
    name: "tools-aerodrome-icao___at",
    path: "/at/tools/aerodrome/:icao()",
    component: () => import("/app/pages/tools/aerodrome/[icao].vue")
  },
  {
    name: "tools-aerodrome-icao___es",
    path: "/es/tools/aerodrome/:icao()",
    component: () => import("/app/pages/tools/aerodrome/[icao].vue")
  },
  {
    name: "tools-aerodrome-icao___uk",
    path: "/uk/tools/aerodrome/:icao()",
    component: () => import("/app/pages/tools/aerodrome/[icao].vue")
  },
  {
    name: "tools-aerodrome-icao___ru",
    path: "/ru/tools/aerodrome/:icao()",
    component: () => import("/app/pages/tools/aerodrome/[icao].vue")
  },
  {
    name: "tools-frequency-icao___en___default",
    path: "/tools/frequency/:icao()",
    component: () => import("/app/pages/tools/frequency/[icao].vue")
  },
  {
    name: "tools-frequency-icao___en",
    path: "/en/tools/frequency/:icao()",
    component: () => import("/app/pages/tools/frequency/[icao].vue")
  },
  {
    name: "tools-frequency-icao___de",
    path: "/de/tools/frequency/:icao()",
    component: () => import("/app/pages/tools/frequency/[icao].vue")
  },
  {
    name: "tools-frequency-icao___at",
    path: "/at/tools/frequency/:icao()",
    component: () => import("/app/pages/tools/frequency/[icao].vue")
  },
  {
    name: "tools-frequency-icao___es",
    path: "/es/tools/frequency/:icao()",
    component: () => import("/app/pages/tools/frequency/[icao].vue")
  },
  {
    name: "tools-frequency-icao___uk",
    path: "/uk/tools/frequency/:icao()",
    component: () => import("/app/pages/tools/frequency/[icao].vue")
  },
  {
    name: "tools-frequency-icao___ru",
    path: "/ru/tools/frequency/:icao()",
    component: () => import("/app/pages/tools/frequency/[icao].vue")
  },
  {
    name: "tools-flightschool___en___default",
    path: "/tools/flightschool",
    meta: index3T38SgftPvwWc3JDNnYhykwB5ig5t9BzcsSH7kpBgGsMeta || {},
    component: () => import("/app/pages/tools/flightschool/index.vue")
  },
  {
    name: "tools-flightschool___en",
    path: "/en/tools/flightschool",
    meta: index3T38SgftPvwWc3JDNnYhykwB5ig5t9BzcsSH7kpBgGsMeta || {},
    component: () => import("/app/pages/tools/flightschool/index.vue")
  },
  {
    name: "tools-flightschool___de",
    path: "/de/tools/flightschool",
    meta: index3T38SgftPvwWc3JDNnYhykwB5ig5t9BzcsSH7kpBgGsMeta || {},
    component: () => import("/app/pages/tools/flightschool/index.vue")
  },
  {
    name: "tools-flightschool___at",
    path: "/at/tools/flightschool",
    meta: index3T38SgftPvwWc3JDNnYhykwB5ig5t9BzcsSH7kpBgGsMeta || {},
    component: () => import("/app/pages/tools/flightschool/index.vue")
  },
  {
    name: "tools-flightschool___es",
    path: "/es/tools/flightschool",
    meta: index3T38SgftPvwWc3JDNnYhykwB5ig5t9BzcsSH7kpBgGsMeta || {},
    component: () => import("/app/pages/tools/flightschool/index.vue")
  },
  {
    name: "tools-flightschool___uk",
    path: "/uk/tools/flightschool",
    meta: index3T38SgftPvwWc3JDNnYhykwB5ig5t9BzcsSH7kpBgGsMeta || {},
    component: () => import("/app/pages/tools/flightschool/index.vue")
  },
  {
    name: "tools-flightschool___ru",
    path: "/ru/tools/flightschool",
    meta: index3T38SgftPvwWc3JDNnYhykwB5ig5t9BzcsSH7kpBgGsMeta || {},
    component: () => import("/app/pages/tools/flightschool/index.vue")
  },
  {
    name: "home-school-lections___en___default",
    path: "/home/school/lections",
    component: () => import("/app/pages/home/school/lections/index.vue")
  },
  {
    name: "home-school-lections___en",
    path: "/en/home/school/lections",
    component: () => import("/app/pages/home/school/lections/index.vue")
  },
  {
    name: "home-school-lections___de",
    path: "/de/home/school/lections",
    component: () => import("/app/pages/home/school/lections/index.vue")
  },
  {
    name: "home-school-lections___at",
    path: "/at/home/school/lections",
    component: () => import("/app/pages/home/school/lections/index.vue")
  },
  {
    name: "home-school-lections___es",
    path: "/es/home/school/lections",
    component: () => import("/app/pages/home/school/lections/index.vue")
  },
  {
    name: "home-school-lections___uk",
    path: "/uk/home/school/lections",
    component: () => import("/app/pages/home/school/lections/index.vue")
  },
  {
    name: "home-school-lections___ru",
    path: "/ru/home/school/lections",
    component: () => import("/app/pages/home/school/lections/index.vue")
  },
  {
    name: "Scenario___en___default",
    path: "/home/school/scenarios/:id()",
    meta: _91id_931U5t1ns0J6X5BW5pu_Q5NmkbTjaiuf_45gfpiz2GxRUf8Meta || {},
    component: () => import("/app/pages/home/school/scenarios/[id].vue")
  },
  {
    name: "Scenario___en",
    path: "/en/home/school/scenarios/:id()",
    meta: _91id_931U5t1ns0J6X5BW5pu_Q5NmkbTjaiuf_45gfpiz2GxRUf8Meta || {},
    component: () => import("/app/pages/home/school/scenarios/[id].vue")
  },
  {
    name: "Scenario___de",
    path: "/de/home/school/scenarios/:id()",
    meta: _91id_931U5t1ns0J6X5BW5pu_Q5NmkbTjaiuf_45gfpiz2GxRUf8Meta || {},
    component: () => import("/app/pages/home/school/scenarios/[id].vue")
  },
  {
    name: "Scenario___at",
    path: "/at/home/school/scenarios/:id()",
    meta: _91id_931U5t1ns0J6X5BW5pu_Q5NmkbTjaiuf_45gfpiz2GxRUf8Meta || {},
    component: () => import("/app/pages/home/school/scenarios/[id].vue")
  },
  {
    name: "Scenario___es",
    path: "/es/home/school/scenarios/:id()",
    meta: _91id_931U5t1ns0J6X5BW5pu_Q5NmkbTjaiuf_45gfpiz2GxRUf8Meta || {},
    component: () => import("/app/pages/home/school/scenarios/[id].vue")
  },
  {
    name: "Scenario___uk",
    path: "/uk/home/school/scenarios/:id()",
    meta: _91id_931U5t1ns0J6X5BW5pu_Q5NmkbTjaiuf_45gfpiz2GxRUf8Meta || {},
    component: () => import("/app/pages/home/school/scenarios/[id].vue")
  },
  {
    name: "Scenario___ru",
    path: "/ru/home/school/scenarios/:id()",
    meta: _91id_931U5t1ns0J6X5BW5pu_Q5NmkbTjaiuf_45gfpiz2GxRUf8Meta || {},
    component: () => import("/app/pages/home/school/scenarios/[id].vue")
  },
  {
    name: "home-school-training___en___default",
    path: "/home/school/training",
    component: () => import("/app/pages/home/school/training/index.vue")
  },
  {
    name: "home-school-training___en",
    path: "/en/home/school/training",
    component: () => import("/app/pages/home/school/training/index.vue")
  },
  {
    name: "home-school-training___de",
    path: "/de/home/school/training",
    component: () => import("/app/pages/home/school/training/index.vue")
  },
  {
    name: "home-school-training___at",
    path: "/at/home/school/training",
    component: () => import("/app/pages/home/school/training/index.vue")
  },
  {
    name: "home-school-training___es",
    path: "/es/home/school/training",
    component: () => import("/app/pages/home/school/training/index.vue")
  },
  {
    name: "home-school-training___uk",
    path: "/uk/home/school/training",
    component: () => import("/app/pages/home/school/training/index.vue")
  },
  {
    name: "home-school-training___ru",
    path: "/ru/home/school/training",
    component: () => import("/app/pages/home/school/training/index.vue")
  },
  {
    name: "Catalogs___en___default",
    path: "/home/school/questions",
    meta: indexexOpWq1WllquRN0wtg8dM5Vl9vnpmSTywBjPdrpEC2cMeta || {},
    component: () => import("/app/pages/home/school/questions/index.vue")
  },
  {
    name: "Catalogs___en",
    path: "/en/home/school/questions",
    meta: indexexOpWq1WllquRN0wtg8dM5Vl9vnpmSTywBjPdrpEC2cMeta || {},
    component: () => import("/app/pages/home/school/questions/index.vue")
  },
  {
    name: "Catalogs___de",
    path: "/de/home/school/questions",
    meta: indexexOpWq1WllquRN0wtg8dM5Vl9vnpmSTywBjPdrpEC2cMeta || {},
    component: () => import("/app/pages/home/school/questions/index.vue")
  },
  {
    name: "Catalogs___at",
    path: "/at/home/school/questions",
    meta: indexexOpWq1WllquRN0wtg8dM5Vl9vnpmSTywBjPdrpEC2cMeta || {},
    component: () => import("/app/pages/home/school/questions/index.vue")
  },
  {
    name: "Catalogs___es",
    path: "/es/home/school/questions",
    meta: indexexOpWq1WllquRN0wtg8dM5Vl9vnpmSTywBjPdrpEC2cMeta || {},
    component: () => import("/app/pages/home/school/questions/index.vue")
  },
  {
    name: "Catalogs___uk",
    path: "/uk/home/school/questions",
    meta: indexexOpWq1WllquRN0wtg8dM5Vl9vnpmSTywBjPdrpEC2cMeta || {},
    component: () => import("/app/pages/home/school/questions/index.vue")
  },
  {
    name: "Catalogs___ru",
    path: "/ru/home/school/questions",
    meta: indexexOpWq1WllquRN0wtg8dM5Vl9vnpmSTywBjPdrpEC2cMeta || {},
    component: () => import("/app/pages/home/school/questions/index.vue")
  },
  {
    name: "home-school-scenarios___en___default",
    path: "/home/school/scenarios",
    component: () => import("/app/pages/home/school/scenarios/index.vue")
  },
  {
    name: "home-school-scenarios___en",
    path: "/en/home/school/scenarios",
    component: () => import("/app/pages/home/school/scenarios/index.vue")
  },
  {
    name: "home-school-scenarios___de",
    path: "/de/home/school/scenarios",
    component: () => import("/app/pages/home/school/scenarios/index.vue")
  },
  {
    name: "home-school-scenarios___at",
    path: "/at/home/school/scenarios",
    component: () => import("/app/pages/home/school/scenarios/index.vue")
  },
  {
    name: "home-school-scenarios___es",
    path: "/es/home/school/scenarios",
    component: () => import("/app/pages/home/school/scenarios/index.vue")
  },
  {
    name: "home-school-scenarios___uk",
    path: "/uk/home/school/scenarios",
    component: () => import("/app/pages/home/school/scenarios/index.vue")
  },
  {
    name: "home-school-scenarios___ru",
    path: "/ru/home/school/scenarios",
    component: () => import("/app/pages/home/school/scenarios/index.vue")
  },
  {
    name: "tools-flightschool-school___en___default",
    path: "/tools/flightschool/:school()",
    component: () => import("/app/pages/tools/flightschool/[school].vue")
  },
  {
    name: "tools-flightschool-school___en",
    path: "/en/tools/flightschool/:school()",
    component: () => import("/app/pages/tools/flightschool/[school].vue")
  },
  {
    name: "tools-flightschool-school___de",
    path: "/de/tools/flightschool/:school()",
    component: () => import("/app/pages/tools/flightschool/[school].vue")
  },
  {
    name: "tools-flightschool-school___at",
    path: "/at/tools/flightschool/:school()",
    component: () => import("/app/pages/tools/flightschool/[school].vue")
  },
  {
    name: "tools-flightschool-school___es",
    path: "/es/tools/flightschool/:school()",
    component: () => import("/app/pages/tools/flightschool/[school].vue")
  },
  {
    name: "tools-flightschool-school___uk",
    path: "/uk/tools/flightschool/:school()",
    component: () => import("/app/pages/tools/flightschool/[school].vue")
  },
  {
    name: "tools-flightschool-school___ru",
    path: "/ru/tools/flightschool/:school()",
    component: () => import("/app/pages/tools/flightschool/[school].vue")
  },
  {
    name: "home-school-training-spelling___en___default",
    path: "/home/school/training/spelling",
    component: () => import("/app/pages/home/school/training/spelling.vue")
  },
  {
    name: "home-school-training-spelling___en",
    path: "/en/home/school/training/spelling",
    component: () => import("/app/pages/home/school/training/spelling.vue")
  },
  {
    name: "home-school-training-spelling___de",
    path: "/de/home/school/training/spelling",
    component: () => import("/app/pages/home/school/training/spelling.vue")
  },
  {
    name: "home-school-training-spelling___at",
    path: "/at/home/school/training/spelling",
    component: () => import("/app/pages/home/school/training/spelling.vue")
  },
  {
    name: "home-school-training-spelling___es",
    path: "/es/home/school/training/spelling",
    component: () => import("/app/pages/home/school/training/spelling.vue")
  },
  {
    name: "home-school-training-spelling___uk",
    path: "/uk/home/school/training/spelling",
    component: () => import("/app/pages/home/school/training/spelling.vue")
  },
  {
    name: "home-school-training-spelling___ru",
    path: "/ru/home/school/training/spelling",
    component: () => import("/app/pages/home/school/training/spelling.vue")
  },
  {
    name: "lection___en___default",
    path: "/home/school/lections/lection-:id()",
    meta: lection_45_91id_93TwJE4cfPjQPSdQGPlKYEYJyk9wDnKpsvlXJiS06ljEkMeta || {},
    component: () => import("/app/pages/home/school/lections/lection-[id].vue")
  },
  {
    name: "lection___en",
    path: "/en/home/school/lections/lection-:id()",
    meta: lection_45_91id_93TwJE4cfPjQPSdQGPlKYEYJyk9wDnKpsvlXJiS06ljEkMeta || {},
    component: () => import("/app/pages/home/school/lections/lection-[id].vue")
  },
  {
    name: "lection___de",
    path: "/de/home/school/lections/lection-:id()",
    meta: lection_45_91id_93TwJE4cfPjQPSdQGPlKYEYJyk9wDnKpsvlXJiS06ljEkMeta || {},
    component: () => import("/app/pages/home/school/lections/lection-[id].vue")
  },
  {
    name: "lection___at",
    path: "/at/home/school/lections/lection-:id()",
    meta: lection_45_91id_93TwJE4cfPjQPSdQGPlKYEYJyk9wDnKpsvlXJiS06ljEkMeta || {},
    component: () => import("/app/pages/home/school/lections/lection-[id].vue")
  },
  {
    name: "lection___es",
    path: "/es/home/school/lections/lection-:id()",
    meta: lection_45_91id_93TwJE4cfPjQPSdQGPlKYEYJyk9wDnKpsvlXJiS06ljEkMeta || {},
    component: () => import("/app/pages/home/school/lections/lection-[id].vue")
  },
  {
    name: "lection___uk",
    path: "/uk/home/school/lections/lection-:id()",
    meta: lection_45_91id_93TwJE4cfPjQPSdQGPlKYEYJyk9wDnKpsvlXJiS06ljEkMeta || {},
    component: () => import("/app/pages/home/school/lections/lection-[id].vue")
  },
  {
    name: "lection___ru",
    path: "/ru/home/school/lections/lection-:id()",
    meta: lection_45_91id_93TwJE4cfPjQPSdQGPlKYEYJyk9wDnKpsvlXJiS06ljEkMeta || {},
    component: () => import("/app/pages/home/school/lections/lection-[id].vue")
  },
  {
    name: "home-school-lections-lection-old-1___en___default",
    path: "/home/school/lections/lection-old-1",
    component: () => import("/app/pages/home/school/lections/lection-old-1.vue")
  },
  {
    name: "home-school-lections-lection-old-1___en",
    path: "/en/home/school/lections/lection-old-1",
    component: () => import("/app/pages/home/school/lections/lection-old-1.vue")
  },
  {
    name: "home-school-lections-lection-old-1___de",
    path: "/de/home/school/lections/lection-old-1",
    component: () => import("/app/pages/home/school/lections/lection-old-1.vue")
  },
  {
    name: "home-school-lections-lection-old-1___at",
    path: "/at/home/school/lections/lection-old-1",
    component: () => import("/app/pages/home/school/lections/lection-old-1.vue")
  },
  {
    name: "home-school-lections-lection-old-1___es",
    path: "/es/home/school/lections/lection-old-1",
    component: () => import("/app/pages/home/school/lections/lection-old-1.vue")
  },
  {
    name: "home-school-lections-lection-old-1___uk",
    path: "/uk/home/school/lections/lection-old-1",
    component: () => import("/app/pages/home/school/lections/lection-old-1.vue")
  },
  {
    name: "home-school-lections-lection-old-1___ru",
    path: "/ru/home/school/lections/lection-old-1",
    component: () => import("/app/pages/home/school/lections/lection-old-1.vue")
  },
  {
    name: "home-school-lections-lection-old-2___en___default",
    path: "/home/school/lections/lection-old-2",
    component: () => import("/app/pages/home/school/lections/lection-old-2.vue")
  },
  {
    name: "home-school-lections-lection-old-2___en",
    path: "/en/home/school/lections/lection-old-2",
    component: () => import("/app/pages/home/school/lections/lection-old-2.vue")
  },
  {
    name: "home-school-lections-lection-old-2___de",
    path: "/de/home/school/lections/lection-old-2",
    component: () => import("/app/pages/home/school/lections/lection-old-2.vue")
  },
  {
    name: "home-school-lections-lection-old-2___at",
    path: "/at/home/school/lections/lection-old-2",
    component: () => import("/app/pages/home/school/lections/lection-old-2.vue")
  },
  {
    name: "home-school-lections-lection-old-2___es",
    path: "/es/home/school/lections/lection-old-2",
    component: () => import("/app/pages/home/school/lections/lection-old-2.vue")
  },
  {
    name: "home-school-lections-lection-old-2___uk",
    path: "/uk/home/school/lections/lection-old-2",
    component: () => import("/app/pages/home/school/lections/lection-old-2.vue")
  },
  {
    name: "home-school-lections-lection-old-2___ru",
    path: "/ru/home/school/lections/lection-old-2",
    component: () => import("/app/pages/home/school/lections/lection-old-2.vue")
  },
  {
    name: "home-school-lections-lection-old-3___en___default",
    path: "/home/school/lections/lection-old-3",
    component: () => import("/app/pages/home/school/lections/lection-old-3.vue")
  },
  {
    name: "home-school-lections-lection-old-3___en",
    path: "/en/home/school/lections/lection-old-3",
    component: () => import("/app/pages/home/school/lections/lection-old-3.vue")
  },
  {
    name: "home-school-lections-lection-old-3___de",
    path: "/de/home/school/lections/lection-old-3",
    component: () => import("/app/pages/home/school/lections/lection-old-3.vue")
  },
  {
    name: "home-school-lections-lection-old-3___at",
    path: "/at/home/school/lections/lection-old-3",
    component: () => import("/app/pages/home/school/lections/lection-old-3.vue")
  },
  {
    name: "home-school-lections-lection-old-3___es",
    path: "/es/home/school/lections/lection-old-3",
    component: () => import("/app/pages/home/school/lections/lection-old-3.vue")
  },
  {
    name: "home-school-lections-lection-old-3___uk",
    path: "/uk/home/school/lections/lection-old-3",
    component: () => import("/app/pages/home/school/lections/lection-old-3.vue")
  },
  {
    name: "home-school-lections-lection-old-3___ru",
    path: "/ru/home/school/lections/lection-old-3",
    component: () => import("/app/pages/home/school/lections/lection-old-3.vue")
  },
  {
    name: "home-school-lections-lection-old-4___en___default",
    path: "/home/school/lections/lection-old-4",
    component: () => import("/app/pages/home/school/lections/lection-old-4.vue")
  },
  {
    name: "home-school-lections-lection-old-4___en",
    path: "/en/home/school/lections/lection-old-4",
    component: () => import("/app/pages/home/school/lections/lection-old-4.vue")
  },
  {
    name: "home-school-lections-lection-old-4___de",
    path: "/de/home/school/lections/lection-old-4",
    component: () => import("/app/pages/home/school/lections/lection-old-4.vue")
  },
  {
    name: "home-school-lections-lection-old-4___at",
    path: "/at/home/school/lections/lection-old-4",
    component: () => import("/app/pages/home/school/lections/lection-old-4.vue")
  },
  {
    name: "home-school-lections-lection-old-4___es",
    path: "/es/home/school/lections/lection-old-4",
    component: () => import("/app/pages/home/school/lections/lection-old-4.vue")
  },
  {
    name: "home-school-lections-lection-old-4___uk",
    path: "/uk/home/school/lections/lection-old-4",
    component: () => import("/app/pages/home/school/lections/lection-old-4.vue")
  },
  {
    name: "home-school-lections-lection-old-4___ru",
    path: "/ru/home/school/lections/lection-old-4",
    component: () => import("/app/pages/home/school/lections/lection-old-4.vue")
  },
  {
    name: "home-school-lections-lection-old-5___en___default",
    path: "/home/school/lections/lection-old-5",
    component: () => import("/app/pages/home/school/lections/lection-old-5.vue")
  },
  {
    name: "home-school-lections-lection-old-5___en",
    path: "/en/home/school/lections/lection-old-5",
    component: () => import("/app/pages/home/school/lections/lection-old-5.vue")
  },
  {
    name: "home-school-lections-lection-old-5___de",
    path: "/de/home/school/lections/lection-old-5",
    component: () => import("/app/pages/home/school/lections/lection-old-5.vue")
  },
  {
    name: "home-school-lections-lection-old-5___at",
    path: "/at/home/school/lections/lection-old-5",
    component: () => import("/app/pages/home/school/lections/lection-old-5.vue")
  },
  {
    name: "home-school-lections-lection-old-5___es",
    path: "/es/home/school/lections/lection-old-5",
    component: () => import("/app/pages/home/school/lections/lection-old-5.vue")
  },
  {
    name: "home-school-lections-lection-old-5___uk",
    path: "/uk/home/school/lections/lection-old-5",
    component: () => import("/app/pages/home/school/lections/lection-old-5.vue")
  },
  {
    name: "home-school-lections-lection-old-5___ru",
    path: "/ru/home/school/lections/lection-old-5",
    component: () => import("/app/pages/home/school/lections/lection-old-5.vue")
  },
  {
    name: "home-school-lections-lection-old-6___en___default",
    path: "/home/school/lections/lection-old-6",
    component: () => import("/app/pages/home/school/lections/lection-old-6.vue")
  },
  {
    name: "home-school-lections-lection-old-6___en",
    path: "/en/home/school/lections/lection-old-6",
    component: () => import("/app/pages/home/school/lections/lection-old-6.vue")
  },
  {
    name: "home-school-lections-lection-old-6___de",
    path: "/de/home/school/lections/lection-old-6",
    component: () => import("/app/pages/home/school/lections/lection-old-6.vue")
  },
  {
    name: "home-school-lections-lection-old-6___at",
    path: "/at/home/school/lections/lection-old-6",
    component: () => import("/app/pages/home/school/lections/lection-old-6.vue")
  },
  {
    name: "home-school-lections-lection-old-6___es",
    path: "/es/home/school/lections/lection-old-6",
    component: () => import("/app/pages/home/school/lections/lection-old-6.vue")
  },
  {
    name: "home-school-lections-lection-old-6___uk",
    path: "/uk/home/school/lections/lection-old-6",
    component: () => import("/app/pages/home/school/lections/lection-old-6.vue")
  },
  {
    name: "home-school-lections-lection-old-6___ru",
    path: "/ru/home/school/lections/lection-old-6",
    component: () => import("/app/pages/home/school/lections/lection-old-6.vue")
  },
  {
    name: "home-school-questions-license___en___default",
    path: "/home/school/questions/:license()",
    meta: indexZLzP_45InkhGD55R6M5FTQRRcGFgO6lVwImxqJzYzwrhQMeta || {},
    component: () => import("/app/pages/home/school/questions/[license]/index.vue")
  },
  {
    name: "home-school-questions-license___en",
    path: "/en/home/school/questions/:license()",
    meta: indexZLzP_45InkhGD55R6M5FTQRRcGFgO6lVwImxqJzYzwrhQMeta || {},
    component: () => import("/app/pages/home/school/questions/[license]/index.vue")
  },
  {
    name: "home-school-questions-license___de",
    path: "/de/home/school/questions/:license()",
    meta: indexZLzP_45InkhGD55R6M5FTQRRcGFgO6lVwImxqJzYzwrhQMeta || {},
    component: () => import("/app/pages/home/school/questions/[license]/index.vue")
  },
  {
    name: "home-school-questions-license___at",
    path: "/at/home/school/questions/:license()",
    meta: indexZLzP_45InkhGD55R6M5FTQRRcGFgO6lVwImxqJzYzwrhQMeta || {},
    component: () => import("/app/pages/home/school/questions/[license]/index.vue")
  },
  {
    name: "home-school-questions-license___es",
    path: "/es/home/school/questions/:license()",
    meta: indexZLzP_45InkhGD55R6M5FTQRRcGFgO6lVwImxqJzYzwrhQMeta || {},
    component: () => import("/app/pages/home/school/questions/[license]/index.vue")
  },
  {
    name: "home-school-questions-license___uk",
    path: "/uk/home/school/questions/:license()",
    meta: indexZLzP_45InkhGD55R6M5FTQRRcGFgO6lVwImxqJzYzwrhQMeta || {},
    component: () => import("/app/pages/home/school/questions/[license]/index.vue")
  },
  {
    name: "home-school-questions-license___ru",
    path: "/ru/home/school/questions/:license()",
    meta: indexZLzP_45InkhGD55R6M5FTQRRcGFgO6lVwImxqJzYzwrhQMeta || {},
    component: () => import("/app/pages/home/school/questions/[license]/index.vue")
  },
  {
    name: "home-school-questions-license-exampreparation___en___default",
    path: "/home/school/questions/:license()/exampreparation",
    component: () => import("/app/pages/home/school/questions/[license]/exampreparation/index.vue")
  },
  {
    name: "home-school-questions-license-exampreparation___en",
    path: "/en/home/school/questions/:license()/exampreparation",
    component: () => import("/app/pages/home/school/questions/[license]/exampreparation/index.vue")
  },
  {
    name: "home-school-questions-license-exampreparation___de",
    path: "/de/home/school/questions/:license()/exampreparation",
    component: () => import("/app/pages/home/school/questions/[license]/exampreparation/index.vue")
  },
  {
    name: "home-school-questions-license-exampreparation___at",
    path: "/at/home/school/questions/:license()/exampreparation",
    component: () => import("/app/pages/home/school/questions/[license]/exampreparation/index.vue")
  },
  {
    name: "home-school-questions-license-exampreparation___es",
    path: "/es/home/school/questions/:license()/exampreparation",
    component: () => import("/app/pages/home/school/questions/[license]/exampreparation/index.vue")
  },
  {
    name: "home-school-questions-license-exampreparation___uk",
    path: "/uk/home/school/questions/:license()/exampreparation",
    component: () => import("/app/pages/home/school/questions/[license]/exampreparation/index.vue")
  },
  {
    name: "home-school-questions-license-exampreparation___ru",
    path: "/ru/home/school/questions/:license()/exampreparation",
    component: () => import("/app/pages/home/school/questions/[license]/exampreparation/index.vue")
  },
  {
    name: "Question___en___default",
    path: "/home/school/questions/:license()/:category()/:number?",
    meta: indexhCGq5apkzhfSLkY5fldINtKN9g7hJTEotNdsAMkQfyEMeta || {},
    component: () => import("/app/pages/home/school/questions/[license]/[category]/[[number]]/index.vue")
  },
  {
    name: "Question___en",
    path: "/en/home/school/questions/:license()/:category()/:number?",
    meta: indexhCGq5apkzhfSLkY5fldINtKN9g7hJTEotNdsAMkQfyEMeta || {},
    component: () => import("/app/pages/home/school/questions/[license]/[category]/[[number]]/index.vue")
  },
  {
    name: "Question___de",
    path: "/de/home/school/questions/:license()/:category()/:number?",
    meta: indexhCGq5apkzhfSLkY5fldINtKN9g7hJTEotNdsAMkQfyEMeta || {},
    component: () => import("/app/pages/home/school/questions/[license]/[category]/[[number]]/index.vue")
  },
  {
    name: "Question___at",
    path: "/at/home/school/questions/:license()/:category()/:number?",
    meta: indexhCGq5apkzhfSLkY5fldINtKN9g7hJTEotNdsAMkQfyEMeta || {},
    component: () => import("/app/pages/home/school/questions/[license]/[category]/[[number]]/index.vue")
  },
  {
    name: "Question___es",
    path: "/es/home/school/questions/:license()/:category()/:number?",
    meta: indexhCGq5apkzhfSLkY5fldINtKN9g7hJTEotNdsAMkQfyEMeta || {},
    component: () => import("/app/pages/home/school/questions/[license]/[category]/[[number]]/index.vue")
  },
  {
    name: "Question___uk",
    path: "/uk/home/school/questions/:license()/:category()/:number?",
    meta: indexhCGq5apkzhfSLkY5fldINtKN9g7hJTEotNdsAMkQfyEMeta || {},
    component: () => import("/app/pages/home/school/questions/[license]/[category]/[[number]]/index.vue")
  },
  {
    name: "Question___ru",
    path: "/ru/home/school/questions/:license()/:category()/:number?",
    meta: indexhCGq5apkzhfSLkY5fldINtKN9g7hJTEotNdsAMkQfyEMeta || {},
    component: () => import("/app/pages/home/school/questions/[license]/[category]/[[number]]/index.vue")
  },
  {
    name: "home-school-questions-license-exampreparation-exam___en___default",
    path: "/home/school/questions/:license()/exampreparation/:exam()",
    component: () => import("/app/pages/home/school/questions/[license]/exampreparation/[exam]/index.vue")
  },
  {
    name: "home-school-questions-license-exampreparation-exam___en",
    path: "/en/home/school/questions/:license()/exampreparation/:exam()",
    component: () => import("/app/pages/home/school/questions/[license]/exampreparation/[exam]/index.vue")
  },
  {
    name: "home-school-questions-license-exampreparation-exam___de",
    path: "/de/home/school/questions/:license()/exampreparation/:exam()",
    component: () => import("/app/pages/home/school/questions/[license]/exampreparation/[exam]/index.vue")
  },
  {
    name: "home-school-questions-license-exampreparation-exam___at",
    path: "/at/home/school/questions/:license()/exampreparation/:exam()",
    component: () => import("/app/pages/home/school/questions/[license]/exampreparation/[exam]/index.vue")
  },
  {
    name: "home-school-questions-license-exampreparation-exam___es",
    path: "/es/home/school/questions/:license()/exampreparation/:exam()",
    component: () => import("/app/pages/home/school/questions/[license]/exampreparation/[exam]/index.vue")
  },
  {
    name: "home-school-questions-license-exampreparation-exam___uk",
    path: "/uk/home/school/questions/:license()/exampreparation/:exam()",
    component: () => import("/app/pages/home/school/questions/[license]/exampreparation/[exam]/index.vue")
  },
  {
    name: "home-school-questions-license-exampreparation-exam___ru",
    path: "/ru/home/school/questions/:license()/exampreparation/:exam()",
    component: () => import("/app/pages/home/school/questions/[license]/exampreparation/[exam]/index.vue")
  },
  {
    name: "home-school-questions-license-exampreparation-exam-result-completion___en___default",
    path: "/home/school/questions/:license()/exampreparation/:exam()/result/:completion()",
    component: () => import("/app/pages/home/school/questions/[license]/exampreparation/[exam]/result/[completion].vue")
  },
  {
    name: "home-school-questions-license-exampreparation-exam-result-completion___en",
    path: "/en/home/school/questions/:license()/exampreparation/:exam()/result/:completion()",
    component: () => import("/app/pages/home/school/questions/[license]/exampreparation/[exam]/result/[completion].vue")
  },
  {
    name: "home-school-questions-license-exampreparation-exam-result-completion___de",
    path: "/de/home/school/questions/:license()/exampreparation/:exam()/result/:completion()",
    component: () => import("/app/pages/home/school/questions/[license]/exampreparation/[exam]/result/[completion].vue")
  },
  {
    name: "home-school-questions-license-exampreparation-exam-result-completion___at",
    path: "/at/home/school/questions/:license()/exampreparation/:exam()/result/:completion()",
    component: () => import("/app/pages/home/school/questions/[license]/exampreparation/[exam]/result/[completion].vue")
  },
  {
    name: "home-school-questions-license-exampreparation-exam-result-completion___es",
    path: "/es/home/school/questions/:license()/exampreparation/:exam()/result/:completion()",
    component: () => import("/app/pages/home/school/questions/[license]/exampreparation/[exam]/result/[completion].vue")
  },
  {
    name: "home-school-questions-license-exampreparation-exam-result-completion___uk",
    path: "/uk/home/school/questions/:license()/exampreparation/:exam()/result/:completion()",
    component: () => import("/app/pages/home/school/questions/[license]/exampreparation/[exam]/result/[completion].vue")
  },
  {
    name: "home-school-questions-license-exampreparation-exam-result-completion___ru",
    path: "/ru/home/school/questions/:license()/exampreparation/:exam()/result/:completion()",
    component: () => import("/app/pages/home/school/questions/[license]/exampreparation/[exam]/result/[completion].vue")
  },
  {
    name: component_45stubxPFW0AyuS0FSsi5abKpdmEVVeey6yOusab24ksP4zsAMeta?.name,
    path: "/sitemap.xml",
    component: component_45stubxPFW0AyuS0FSsi5abKpdmEVVeey6yOusab24ksP4zsA
  },
  {
    name: component_45stubxPFW0AyuS0FSsi5abKpdmEVVeey6yOusab24ksP4zsAMeta?.name,
    path: "/en/sitemap.xml",
    component: component_45stubxPFW0AyuS0FSsi5abKpdmEVVeey6yOusab24ksP4zsA
  },
  {
    name: component_45stubxPFW0AyuS0FSsi5abKpdmEVVeey6yOusab24ksP4zsAMeta?.name,
    path: "/de/sitemap.xml",
    component: component_45stubxPFW0AyuS0FSsi5abKpdmEVVeey6yOusab24ksP4zsA
  },
  {
    name: component_45stubxPFW0AyuS0FSsi5abKpdmEVVeey6yOusab24ksP4zsAMeta?.name,
    path: "/at/sitemap.xml",
    component: component_45stubxPFW0AyuS0FSsi5abKpdmEVVeey6yOusab24ksP4zsA
  },
  {
    name: component_45stubxPFW0AyuS0FSsi5abKpdmEVVeey6yOusab24ksP4zsAMeta?.name,
    path: "/es/sitemap.xml",
    component: component_45stubxPFW0AyuS0FSsi5abKpdmEVVeey6yOusab24ksP4zsA
  },
  {
    name: component_45stubxPFW0AyuS0FSsi5abKpdmEVVeey6yOusab24ksP4zsAMeta?.name,
    path: "/uk/sitemap.xml",
    component: component_45stubxPFW0AyuS0FSsi5abKpdmEVVeey6yOusab24ksP4zsA
  },
  {
    name: component_45stubxPFW0AyuS0FSsi5abKpdmEVVeey6yOusab24ksP4zsAMeta?.name,
    path: "/ru/sitemap.xml",
    component: component_45stubxPFW0AyuS0FSsi5abKpdmEVVeey6yOusab24ksP4zsA
  }
]